<template>
  <div>
    <!-- <app-detail-header :show-toggle="true"
      v-if="entity && !uninterruptedView"
      :entity="entity"
      :show-new="false"
      :show-print="entity && !entity.isNew"
      :show-delete="entity && !entity.deleted && !entity.isNew && !readOnlyView && !isInvoiced"
      :show-save="showSaveButton"
      :show-lock="showLock"
      :show-price-parts-msg="!entity.isNew && canViewPricePartsMsg"
      :show-quote-template="showQuoteTemplate"
      :quote-template-disabled="quoteTemplateDisabled"
      :quote-cancelled="isQuoteCancelledByInsurer"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked"
      :show-calendar="isRepx"
      :show-additional-quote-buttons="showQuoteActionButton"
      :show-additional-quote="showNewAdditional"
    />-->

    <module-detail-header
      v-if="entity && !uninterruptedView"
      :entity="entity"
      :show-new="false"
      :show-print="entity && !entity.isNew"
      :show-delete="entity && !entity.deleted && !entity.isNew && !readOnlyView && !isInvoiced"
      :show-save="showSaveButton"
      :auto-save-enabled="autoSaveEnabled"
      :manual-save-enabled="autoSaveManualSaveEnabled"
      :show-lock="showLock"
      :show-price-parts-msg="!entity.isNew && canViewPricePartsMsg"
      :show-quote-template="showQuoteTemplate"
      :quote-template-disabled="quoteTemplateDisabled"
      :quote-cancelled="isQuoteCancelledByInsurer"
      :show-auto-save="autoSaveEnabled"
      :auto-save-status="quoteSaveStatus"
      :is-saving="autoSaveStatus.isSaving || isSaving"
      :has-auto-save-failed="autoSaveStatus.isFailed"
      :unsaved-changes="autoSaveStatus.isDiffChanged"
      :auto-save-locked="(entity && entity.isNew) || !autoSaveEnabled || autoSaveStatus.isFailed"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked"
      @manual-save-request="handleManualSaveRequest"
      @toggle-auto-save="toggleAutoSave"
      :show-calendar="isRepx"
      :show-additional-quote-buttons="showQuoteActionButton"
      :show-additional-quote="showNewAdditional"
      :show-toggle="false">

      <!-- Desktop title area -->
      <template #desktop-left>
        <article class="horizontal-menu-article">
          <span v-show="$user.info.isSupportUser && hasFlexiShopIntegration"
            class="icon is-synced-icon"
            :class="[ entity.isSynced ? 'has-text-success' : 'has-text-warning' ]">
            <i class="mdi mdi-circle-medium mdi-36px" />
          </span>
          <!-- First Row: Quote No and Subquotes -->
          <section class="quote-header-row">
            <div class="quote-info is-flex">
              <span class="is-5 is-flex is-align-items-center">
                <span class="is-size-4 has-text-weight-bold mx-1">
                  {{ [entity.prefix, entity.quoteNo, entity.suffix].join('') || '-' }}
                </span>
              </span>
            </div>
            <div class="is-flex is-align-items-center">
              <span class="is-flex tooltip is-tooltip-bottom"
                data-tooltip="Authorised Quote">
                <span v-if="entity && !entity.isNew && isAuthorised"
                  class="mso mso-24px has-text-grey-light">
                  shield
                </span>
              </span>
              <div v-if="entity.isNew || readOnlyView"
                class="ml-1">
                <span class="tag is-rounded job-stage is-5">{{ jobNSubJobStageCompositeName }}</span>
              </div>
              <div v-else
                class="field ml-1"
                style="margin-bottom: 0;">
                <div class="control">
                  <div class="select job-stage-select">
                    <select v-model="innerJobNSubJobStageCompositeKey"
                      @change="handleJobNSubJobStageChanged"
                      style="min-width: 150px;">
                      <template v-for="jobStageGroup in jobNSubJobStagesOptions">
                        <!-- Main job stage option (only if no sub-stages) -->
                        <option v-if="jobStageGroup.subStages.length === 0"
                          :key="`main-${jobStageGroup.jobStageId}`"
                          :value="`${jobStageGroup.mainStage.compositeKey}`">
                          {{ formatJobStage(jobStageGroup.jobStageName) }}
                        </option>
                        <!-- Sub job stages grouped under optgroup if they exist -->
                        <optgroup v-if="jobStageGroup.subStages.length > 0"
                          :key="`group-${jobStageGroup.jobStageId}`"
                          :label="formatJobStage(jobStageGroup.jobStageName)">
                          <!-- Parent job stage as non-selectable option (only show if currently selected) -->
                          <option v-if="innerJobNSubJobStageCompositeKey === jobStageGroup.mainStage.compositeKey"
                            :key="`parent-${jobStageGroup.jobStageId}`"
                            :value="`${jobStageGroup.mainStage.compositeKey}`"
                            disabled>
                            {{ formatJobStage(jobStageGroup.jobStageName) }}
                          </option>
                          <!-- Sub job stages -->
                          <option v-for="subStage in jobStageGroup.subStages"
                            :value="subStage.compositeKey"
                            :key="subStage.compositeKey"
                            :disabled="subStage.disabled">
                            {{ formatJobStage(subStage.subJobStageName) }}
                          </option>
                        </optgroup>
                      </template>
                    </select>
                  </div>
                </div>
              </div>
              <!-- <span class="is-5">
                <span class="is-size-6 has-text-weight-semibold">Status:</span>
              </span> -->
            </div>
            <div v-if="entity && entity.subQuoteNos && entity.subQuoteNos.length >= 1 && !entity.isNew && !entity.isAssessmentEnabled"
              class="subquotes-tabs">
              <div class="tags">
                <span class="is-size-6 has-text-weight-semibold">Quote:</span>
                <router-link
                  v-for="(sub) in entity.subQuoteNos"
                  :key="sub.key"
                  :to="{ name: $route.name, params: { quoteId : sub.value }, query: $route.query }"
                  :class="{
                    'is-primary': sub.key === entity.subQuoteNo,
                    'has-text-white': sub.key === entity.subQuoteNo,
                    'is-disabled': entity.isNew && sub.key !== entity.subQuoteNo
                  }"
                  class="tag is-rounded"
                  @click.native.prevent="goToRoute({ name: $route.name, params: { quoteId : sub.value }, query: $route.query })"
                  exact>
                  <span v-show="entity.readOnlyStatuses[sub.key]"
                    style="margin-left: 0.1em; margin-right: 0.1em"
                    class="icon is-small">
                    <i class="icon mdi mdi-lock-outline" />
                  </span>
                  <span :class="{ 'has-badge-warning has-badge-small has-badge-rounded has-badge-offset2': entity.isNew && sub.key === currentsubquote }"
                    :data-badge="entity.isNew && sub.key === currentsubquote ? '' : null">
                    {{ sub.key === 0 ? 'Main' : `Add-${sub.key}` }}
                  </span>
                </router-link>
              </div>
            </div>
            <div v-if="!entity.isNew"
              class="is-flex quote-header-info thin-scrollbar">
              <div
                class="is-flex is-hidden-desktop-only">
                <div v-if="customer"
                  class="mr-5 is-flex is-align-items-center is-info tooltip is-tooltip-bottom"
                  :data-tooltip="customer.fullname">
                  <span class="mso mso-24px has-text-grey-light mr-1">person</span>
                  <span class="has-text-weight-semibold">{{ truncate(customer.fullname, customerAndVehicleMakeModelMaxLength) }}</span>
                </div>
                <div v-if="vehicle"
                  class="is-flex is-align-items-center is-info tooltip is-tooltip-bottom"
                  :data-tooltip="`${vehicle.rego} - ${vehicle.model.name}`">
                  <span class="mso mso-24px has-text-grey-light mr-1">directions_car</span>
                  <span class="has-text-weight-semibold">{{ truncate(`${vehicle.rego} - ${vehicle.model.name}`, customerAndVehicleMakeModelMaxLength) }}</span>
                </div>
              </div>
              <div
                class="is-flex"
                style="gap: 0.7rem;">
                <div>
                  <span class="is-size-6 has-text-weight-semibold">Total <span class="subtext mr-2">(Ex GST)</span></span>
                  <span class="has-text-success">{{ $filters.formatCurrency(totalExGst, $userInfo.locale) }}</span>
                </div>
                <div>
                  <span class="is-size-6 has-text-weight-semibold">Total <span class="subtext mr-2">(Inc GST)</span></span>
                  <span class="has-text-success">{{ $filters.formatCurrency(totalIncGst, $userInfo.locale) }}</span>
                </div>
              </div>
            </div>

          </section>
        </article>
      </template>

      <!-- Center warning for cancelled quotes -->
      <template #center
        v-if="isQuoteCancelledByInsurer">
        <span class="is-size-6 tag is-danger is-light">
          <span class="mdi mdi-alert-outline mr-3" />
          <span style="word-break: break-word;">Cancelled by insurer. Please copy the quote to work on it as a private job.</span>
        </span>
      </template>

      <template #more-menu-items>
        <div v-if="entity && !entity.isNew && entity.deleted"
          class="is-divider" />
        <li v-if="entity && !entity.isNew && entity.deleted">
          <a class="is-flex is-align-items-center has-text-success"
            @click="onHeaderButtonClicked('restore')">
            <span class="mso mso-20px icon pr-3">
              restore_from_trash
            </span>
            <span>Restore</span>
          </a>
        </li>
        <div v-if="($userInfo.isSupportUser || $userInfo.isCustomerAdministrator || tempGemCan) && isMainQuote"
        />
        <li v-if="($userInfo.isSupportUser || $userInfo.isCustomerAdministrator || tempGemCan) && isMainQuote">
          <a class="is-flex is-align-items-center"
            @click="onHeaderButtonClicked('enableAssessmentHistory')">
            <span class="mso mso-20px icon pr-3">
              {{ entity.isAssessmentEnabled ? 'check_box' : 'check_box_outline_blank' }}
            </span>
            <span>Enable Assessment History</span>
          </a>
        </li>
      </template>

      <!-- Desktop right area - removed toggle, now in ModuleDetailHeader -->

    </module-detail-header>

    <!-- NEW HORIZONTAL MENU BELOW HEADER -->
    <!-- <quote-horizontal-menu v-if="entity && !uninterruptedView && showHorizontalMenu"
      :entity-name="`${entity.quoteNo}`"
      v-model="entity"
      :vehicle="vehicle"
      :customer="customer" /> -->

    <!-- Quote Sub Navigation Menu -->
    <quote-sub-nav v-if="entity && !uninterruptedView && showHorizontalMenu"
      :value="entity"
      :insurer="insurer"
      :orm-unread-message-count="ormUnreadMessageCount" />
    <QuoteBanner
      v-if="!isOrmEditedQuote"
      :title="'Quote Editing Locked'"
      :message="'Editing is disabled while a payment authorisation is in progress.'"
      type="warning"
      icon="warning"
      :banner-visible="true"
    />

    <div class="columns is-gapless quote-body">
      <div class="column is-narrow ml-3 mb-3"
        v-if="isQuoteBuilder">
        <quote-builder-sidebar
          v-model="entity"
          :selected-menu="selectedMenu"
          :selected-sub-sections.sync="selectedSubSections"
          :selected-area.sync="selectedArea"
          :available-items-type="availableItemsType"
          :is-quote-editable="isQuoteEditable"
          @update:selectedMenu="selectedMenu = $event"
          @modify="modifySelections"
          @reset="resetSelections" />
      </div>
      <div class="column mx-3 mt-0 mb-3">
        <router-view v-if="entity && vehicle && customer && insurer"
          v-model="entity"
          :is-tiled="false"
          :key="$route.fullPath"
          :route-name="$route.name"
          :vehicle.sync="vehicle"
          :customer.sync="customer"
          :insurer.sync="insurer"
          :quote-cycle-time.sync="entity.quoteCycleTime"
          :next-line-number="nextLineNumber"
          @onOpgCodeChanged="onOpgCodeChanged"
          :read-only-view="readOnlyView"
          :audanet-lock="audanetLock"
          :price-parts-return-route="pricePartsReturnRoute"
          :snapshot-diff="snapshotDiff"
          :orm-unread-message-count="ormUnreadMessageCount"
          :show-quote-template="showQuoteTemplate"
          :selected-area="selectedArea"
          :selected-sub-sections="selectedSubSections"
          :is-new-customer-prompt="isNewCustomerPrompt"
          @customer-component-blur="queueHeaderAutosave('customer')"
          @vehicle-component-blur="queueHeaderAutosave('vehicle')"
          @insurer-component-blur="queueHeaderAutosave('insurer')"
          @booking-component-blur="queueHeaderAutosave('booking')"
          :header-saving-panels="headerSavingPanels"
          :is-quote-editable="isQuoteEditable"
          :auto-save-enabled="autoSaveEnabled"
          @remarks-save-state-change="onRemarksSaveStateChange"
          @remarks-saved="onRemarksSaved"
          @updateQuoteItemsDefaultPaintGroup="updateQuoteItemsDefaultPaintGroup"
          @getEntity="getEntity"
          @select-vehicle="selectVehicle"
          @select-customer="selectCustomer"
          @select-insurer="selectInsurer"
          @save="save"
          @hide-header-buttons="hideHeaderButtons"
          @downloadPartsCheckPrice="downloadPartsCheckPrice"
          @addRepairQuoteTemplateItems="id => addRepairQuoteTemplateItems(id)"
          @handleAddTemplateItemsCustom="obj => addRepairQuoteTemplateItemsCustom(obj)"
          @save-repx-repair-stages="handleSaveRepxRepairStages"
          @avaliableItemsTypeChanged="availableItemsTypeChanged"
          @update:selectedMenu="selectedMenu = $event"
          ref="routerView" />
      </div>
    </div>

    <print-options-modal v-if="isPrintOptionsActive"
      :active.sync="isPrintOptionsActive"
      @cancel="closeModal()"
      @ok="closeModal()"
      :show-icon="true"
      :attach-disabled="false"
      :cancel-disabled="false"
      :value="entity">
      <p slot="text-title">Print Options</p>
    </print-options-modal>
    <invoice-print-options-modal v-if="isInvoicePrintOptionsActive"
      :active.sync="isInvoicePrintOptionsActive"
      @ok="isInvoicePrintOptionsActive = false"
      @cancel="isInvoicePrintOptionsActive = false"
      :show-icon="true"
      :cancel-disabled="false"
      :value="entity">
      <p slot="text-title">Invoice Print Options</p>
    </invoice-print-options-modal>
    <!-- <vue-fab v-show="showQuoteActionButton"
      position="bottom-right"
      :z-index="30"
      :actions="fabActions"
      main-tooltip="Quote Actions"
      @newAdditional="newAdditional"
      @sendSms="sendSms"
      @copyQuote="showCopyQuoteModal"
      @exportQuote="exportQuote" /> -->
    <sms-modal v-if="isSmsModalActive"
      :active.sync="isSmsModalActive"
      v-model="smsDetails"
      @close="closeSmsModal" />
    <copy-quote-modal v-if="isCopyQuoteModalActive"
      :active.sync="isCopyQuoteModalActive"
      v-model="entity"
      :image-ids="imageIds"
      @copy="copyQuote"
      @cancel="isCopyQuoteModalActive = false" />
    <quote-export-modal v-if="isQuoteExportModalActive"
      :active.sync="isQuoteExportModalActive"
      v-model="entity"
      :vehicle="quoteVehicle"
      :default-email="insurerDefaultEmail"
      @close="closeQuoteExportModal" />
    <confirm-modal v-if="isNavigationWarningModalActive"
      :active.sync="isNavigationWarningModalActive"
      @ok="handleNavigationWarningConfirm()"
      @cancel="handleNavigationWarningCancel()"
      :ok-text="navigationWarningAction === 'deleteEmpty' ? 'Continue' : navigationWarningAction === 'leaveWithErrors' ? 'Leave Anyway' : 'Try Manual Save'"
      :cancel-text="navigationWarningAction === 'deleteEmpty' ? 'Keep Editing' : navigationWarningAction === 'leaveWithErrors' ? 'Stay to Fix' : 'Skip Anyway'">
      <p slot="text-title">Navigation Warning</p>
      <p slot="text-content">{{ navigationWarningMessage }}</p>
    </confirm-modal>
    <unsaved-modal :active.sync="isUnsavedModalActive"
      @close="closeModal()"
      @skipSave="skipSave()"
      @saveContinue="saveContinue()">
      <p slot="text-title">Unsaved Changes</p>
      <p slot="text-content">There are unsaved changes. Please select action below</p>
    </unsaved-modal>
    <confirm-modal v-if="entity"
      :active.sync="isConfirmModalActive"
      @ok="deleteEntity(true)"
      @cancel="deleteEntity(false)"
      :ok-text="'Yes'"
      :cancel-text="'No'">
      <p slot="text-title">Delete {{ entity.subQuoteNo > 0 ? 'Supplementry' : '' }} Quote</p>
      <p slot="text-content">
        {{ entity.subQuoteNo > 0 ? 'Supplementry' : '' }} Quote
        <span class="has-text-primary has-text-weight-bold">{{ `${deleteQuoteMessage}` }}</span> will be deleted. Continue?
      </p>
    </confirm-modal>
    <BulmaMessage v-if="entity"
      v-model="isRestoreAllConfirmModalActive"
      type="is-warning"
      title="Restore Quote"
      :closable="true"
      @close="confirmRestoreAll(false)">
      <p>
        <template v-if="entity.subQuoteNo > 0">
          Supplementaries cannot be restored without restoring the delete Main.<br/><br/>
        </template>
        Restore '<span class="has-text-primary has-text-weight-bold">{{ `${entity.prefix}${entity.quoteNo}${entity.suffix}` }}
          and all supplementary quotes</span>'?
        Continue
      </p>
      <template #footer>
        <button
          class="button is-danger"
          @click="confirmRestoreAll(false)">
          No
        </button>
        <button
          class="button is-primary"
          @click="confirmRestoreAll(true)">
          Yes
        </button>
      </template>
    </BulmaMessage>
    <confirm-modal :active.sync="isCustomerCreateModifyModalActive"
      @ok="handleCustomerModalSave"
      @cancel="handleCustomerModalCancel"
      :ok-text="'Save'"
      :cancel-text="'Cancel'">
      <div slot="text-title">Update Customer</div>
      <div slot="text-content">
        <div class="new-owner-prompt-container">
          <p class="has-text-weight-bold mb-5">You are about to update the customer details. What would you like to do?</p>
          <div class="field"
            :class="`theme-${$theme.name} has-background-${$theme.name}`">
            <label class="custom-radio radio is-flex p-4 mb-3"
              :class="[
                { 'is-selected': customerModalSelection === 'create' },
                customerModalSelection === 'create' && `has-text-${$theme.name}-invert`
              ]">
              <input
                v-model="customerModalSelection"
                type="radio"
                value="create">
              <span class="check" />
              <span class="control-label ml-3">
                Create a new customer profile and assign the vehicle to them. A new vehicle record will be created with the same registration, linked to a new customer.
              </span>
            </label>
          </div>
          <div class="field"
            :class="`theme-${$theme.name} has-background-${$theme.name}`">
            <label class="custom-radio radio is-flex p-4"
              :class="[
                { 'is-selected': customerModalSelection === 'modify' },
                customerModalSelection === 'modify' && `has-text-${$theme.name}-invert`
              ]">
              <input
                v-model="customerModalSelection"
                type="radio"
                value="modify">
              <span class="check" />
              <span class="control-label ml-3">
                Update the existing customer's details. All quotes <b>( {{ affectedQuotesCount }} )</b> with this registration will be updated with the customer information.
              </span>
            </label>
          </div>
        </div>
      </div>
    </confirm-modal>
    <save-conflict-modal v-if="entity"
      :active.sync="isSaveConflictModalActive"
      @merge="conflictMerge"
      @reload="conflictReload"
      @close="isSaveConflictModalActive = false">
      <p slot="text-title">Quote Conflict</p>
      <p slot="text-content">
        Quote <span class="has-text-primary has-text-weight-bold">{{ `${entity.prefix}${entity.quoteNo}${entity.suffix}` }}</span> is newer on the server. Reload/Merge/Cancel?
        <br><br>
        <span class="has-text-weight-bold">Reload</span> - <span class="is-italic">Reload quote and lose changes</span><br>
        <span class="has-text-weight-bold">Merge</span> - <span class="is-italic">Local quote changes take precedence. Added items will be merged</span><br>
      </p>
    </save-conflict-modal>
    <!-- <pre v-if="$v">{{ $v }}</pre> -->
    <xml-viewer-modal v-if="isXmlViewerModalActive"
      :active.sync="isXmlViewerModalActive"
      :quote-id="entity.quoteId"
      :message-type="messageType"
      @close="isXmlViewerModalActive = false">
      <p slot="text-title">View {{ messageType }} Messages</p>
    </xml-viewer-modal>
    <quote-template-apply-modal v-if="isQuoteTemplateModalActive"
      :active.sync="isQuoteTemplateModalActive"
      :quote-times-type="entity.labourType"
      :vehicle-body-id="vehicle.bodyId"
      @add="addRepairQuoteTemplateItems">
      <p slot="text-title">Apply Quote Template</p>
    </quote-template-apply-modal>
    <vehicle-butter-fly-selector-modal
      v-if="isVehicleButterflyModalActive"
      :active.sync="isVehicleButterflyModalActive"
      v-model="selectedSubSections"
      :entity="entity"
      @done="handleVehicleButterflyDone"
      @cancel="handleVehicleButterflyCancel" />
  </div>
</template>

<script>
import QuoteRoutes from './route-types'
import QuoteValidation from './QuoteValidation'
import { CustomerService, VehicleService, InsurerService, OrmService } from '@/services'
import {
  AppHeaderButtonTypes,
  RemarkTypes,
  EventHubTypes,
  PhoneTypes,
  InvoiceTypes,
  LabourTimeTypes,
  ItemCategoryTypes,
  QuoteItemStatusTypes,
  AssetTypes,
  PaintGroupTypes,
  JobStageTypes,
  OrmQuoteStatusTypes,
  EmailAssetTypes,
  QuotingMethodTypes
} from '@/enums'
import StoreMixin from './storeMixin'
import _cloneDeep from 'lodash.clonedeep'
import _debounce from 'lodash/debounce'
import _isEmpty from 'lodash/isEmpty'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { UnsavedModal, ConfirmModal, SaveConflictModal } from '@/components/BulmaModal'
import { Emailer } from '@/classes'
import PrintPreviewRoutes from '@/components/printpreview/route-types'
import StoreUtil from '@/store/utils'
import { PrintOptionsModal, InvoicePrintOptionsModal, CopyQuoteModal, QuoteExportModal } from './components'
import QuoteService from './QuoteService'
import HttpStatus from '@/components/http-status'
import InsurerRoutes from '@/views/insurer/route-types'
import VehicleRoutes from '@/views/vehicle/route-types'
import { QuoteLabourMixin, QuoteOtherLabourMixin, QuotePartMixin, QuoteOpgMixin, QuoteMiscMixin, QuoteSubletMixin, QuoteNotificationMixin, ScreenMixin } from './mixins'
import { SmsModal } from '@/components/Sms'
import { SmsSendMessageModel, QuoteItemModel, QuoteItemPresentAsModel } from '@/classes/viewmodels'
import Guid from '@/components/Guid'
import { KeyValuePairModel } from '@/classes/viewmodels'
import { QuoteTemplateService } from '@/services'
import { DeepDiff } from 'deep-diff'
import { PartsCheckService } from './services'
import { XmlViewerModal } from '@/components/XmlViewer'
import QuoteTemplateApplyModal from '@/components/QuoteTemplateModal/QuoteTemplateApplyModal'
import BookingRoutes from '@/views/booking/route-types'
import RepxService from '@/views/repx/RepxService'
import OrmMessageService from '../ormmessage/OrmMessageService'
import QuoteBuilderSidebar, { MENU_MODES as QUOTE_BUILDER_SIDEBAR_MENU_MODES } from '@/components/QuoteBuilderSidebar.vue'
import VehicleButterFlySelectorModal from '@/components/VehicleButterFlySelectorModal.vue'
import ModuleDetailHeader from '@/components/ModuleDetailHeader'
import QuoteSubNav from './QuoteSubNav'
import { CompanyService } from '@/services'
import { createAutoSaveHelper } from './helpers/QuoteAutoSaveHelper'
import { syncPartPaintLoading } from './helpers/PartsCheckSyncPartHelper'
import QuoteBanner from '@/components/QuoteBanner/QuoteBanner.vue'
import BulmaMessage from '@/components/BulmaMessage/BulmaMessage.vue'
import { MessageTypes } from '@/enums'
import * as Sentry from '@sentry/vue'

// Serialize deep-diff results to a JSON string so the full pending-change detail survives
// Sentry's normalizeDepth truncation (which otherwise renders nested values as [Array]/[DiffNew]).
function stringifyDiff(diffs) {
  if (!diffs) return null
  try {
    const str = JSON.stringify(diffs)
    return str && str.length > 10000 ? str.slice(0, 10000) + '…(truncated)' : str
  } catch (e) {
    return String(diffs)
  }
}

export default {
  name: 'QuoteView',
  components: {
    UnsavedModal,
    PrintOptionsModal,
    InvoicePrintOptionsModal,
    SmsModal,
    CopyQuoteModal,
    ConfirmModal,
    QuoteExportModal,
    SaveConflictModal,
    XmlViewerModal,
    QuoteTemplateApplyModal,
    QuoteBuilderSidebar,
    VehicleButterFlySelectorModal,
    ModuleDetailHeader,
    QuoteSubNav,
    QuoteBanner,
    BulmaMessage
  },
  mixins: [
    QuoteValidation,
    StoreMixin,
    QuoteLabourMixin,
    QuoteOtherLabourMixin,
    QuotePartMixin,
    QuoteOpgMixin,
    QuoteMiscMixin,
    QuoteSubletMixin,
    QuoteNotificationMixin,
    ScreenMixin
  ],
  props: {
    returnUrl: {
      type: String,
      default: ''
    },
    invoiceType: {
      type: Number,
      default: 1
    },
    currentsubquote: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      entity: null,
      entityMainQuote: null,
      isSkipSave: false,
      isSaveContinue: false,
      isUnsavedModalActive: false,
      isQuoteTemplateModalActive: false,
      isSaveConflictModalActive: false,
      toRoute: null,
      isPrintOptionsActive: false,
      isInvoicePrintOptionsActive: false,
      isSmsModalActive: false,
      isQuoteExportModalActive: false,
      smsDetails: null,
      isCopyQuoteModalActive: false,
      isConfirmModalActive: false,
      isRestoreAllConfirmModalActive: false,
      isNavigationWarningModalActive: false,
      navigationWarningMessage: '',
      navigationWarningAction: null,
      skipNextNavWarning: false,
      skipNextUnsavedModal: false,
      leaveWithUnsavedErrors: false,
      exportType: 'text',
      imageIds: [],
      fabActions: [],
      audanetSetting: null,
      pnetSetting: null,
      vehicle: null,
      customer: null,
      insurer: null,
      isCustomerCreateModifyModalActive: false,
      customerSaveAction: '',
      customerModalSelection: 'create',
      pricePartsReturnRoute: null,
      isHeaderButtonHided: false,
      isXmlViewerModalActive: false,
      messageType: '',
      quoteTemplateDisabled: true,

      supplementaryQuotes: null,

      isSaving: false,
      isLoading: false,
      templateQuoteItemCount: 0,

      // for orm quotes only
      ormUnreadMessageCount: 0,

      // Stable baseline for header autosave diffs (deep ers often provide an unusable oldVal).
      headerAutosaveBaseline: {
        vehicle: null,
        customer: null,
        insurer: null
      },
      suppressHeaderAutosave: false,
      headerAutosaveToken: 0,
      headerAutosaveInFlight: false,
      headerSavingPanels: { vehicle: false, customer: false, insurer: false, booking: false },

      /// autosave status object
      autoSaveStatus: {
        isSaving: false,
        isEditing: false,
        isDiffChanged: false,
        isFailed: false,
        failMessage: ''
      },
      autoSaveFailureCount: 0,
      autoSaveFailureLimit: 1,
      autoSaveDisabled: false,
      autoSaveEnabledToggle: true,

      showHorizontalMenu: true,

      selectedMenu: QUOTE_BUILDER_SIDEBAR_MENU_MODES.VEHICLE,
      // Butterfly modal state
      isButterflyModalActive: false,
      selectedArea: null,
      selectedSubSections: [],
      // Vehicle Butterfly modal state
      isVehicleButterflyModalActive: false,
      // selectedVehicleSections: []

      showCustomOption: true,
      innerJobNSubJobStageCompositeKey: null,
      availableItemsType: 'PARTS',

      initialQuoteCustomer: null,
      affectedQuotesCount: 0,
      derivedItemUpdateDepth: 0
    }
  },
  computed: {

    autoSaveEnabled() {
      const companySetting = this.$company?.setting?.quoteAutoSaveEnabled
      const companyEnabled = typeof companySetting === 'boolean' ? companySetting : false
      return companyEnabled && !this.autoSaveDisabled
    },
    // When autosave is on, show the manual Save button only for companies opted into keeping it
    // (Experiment 2). Pilot shops (setting false / default) have the button removed entirely.
    autoSaveManualSaveEnabled() {
      return this.$company?.setting?.autoSaveManualSaveEnabled === true
    },
    // Autosave is company-enabled AND can actually save this quote. New quotes are never
    // autosaved (every pipeline guards on isAnyEntityNew), so navigation guards must fall
    // back to the unsaved-changes prompt for them instead of assuming autosave covers it.
    autoSaveActiveForQuote() {
      return this.autoSaveEnabled && !!this.entity && !this.entity.isNew
    },
    // hide if curretroute is quoteBuilder
    hideSaveButton() {
      return this.$route.name === QuoteRoutes.QuoteBuilder.name
    },
    showSaveButton() {
      if (!this.entity || this.readOnlyView)return false

      if (this.autoSaveStatus.isFailed)  return true

      // Show save button when autosave is disabled
      if (!this.autoSaveEnabled) return true

      return !this.isHeaderButtonHided
    },
    quoteSaveStatus() {
      if (this.autoSaveStatus.isFailed) return 'Autosave failed'
      if (!this.entity || !this.entity.modifiedDate) return 'Not saved yet'
      if(!!this.snapshotDiff) return 'Unsaved changes'
      const savedDate = new Date(this.entity.modifiedDate + 'Z')
      return 'Saved on ' + savedDate.toLocaleString('en-AU', {
        timeZone: 'Australia/Brisbane',
        hour12: true,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    totalExGst() {
      if (this.entity) {
        return roundAwayFromZero(
          this.entity.rrTotal +
            this.entity.repairTotal +
            this.entity.rwaTotal +
            this.entity.paintTotal +
            this.entity.partTotal +
            this.entity.opgTotal +
            this.entity.fgTotal +
            this.entity.crushTotal +
            this.entity.cdTotal +
            this.entity.mechTotal +
            this.entity.miscTotal +
            this.entity.sublTotal
        )
      }
    },
    gst() {
      if (this.entity) {
        return roundAwayFromZero(this.totalExGst * (this.entity.gstRate / 100))
      }
    },
    totalIncGst() {
      return roundAwayFromZero(this.totalExGst + this.gst)
    },
    maxLineNumber() {
      const numbers = [
        Math.max(...this.entity.labours.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.parts.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.opgs.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.others.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.miscs.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.sublets.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0)
      ]
      return numbers
    },
    nextLineNumber() {
      // return this.entity.lines
      const numbers = [
        Math.max(...this.entity.labours.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.parts.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.opgs.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.others.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.miscs.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        Math.max(...this.entity.sublets.filter((i) => !(i.isNew && i.deleted)).map((i) => i.lineNumber), 0),
        this.entity.lines - 1
      ]
      return Math.max(...numbers) + 1
    },
    validateError() {
      this.$v.quoteHeaderGroup.$touch()
      this.$v.customer.companyName.$touch()
      this.$v.customer.firstname.$touch()
      this.$v.customer.lastname.$touch()

      // Base (non-ORM) validators only. ORM-only validators (entity.odometer,
      // jobStart, jobEnd, damageSeverity, refuseBookRepairReason,
      // repairLateReason, claimNo ORM sub-rules, vehicle.bodyId2/buildMonth/
      // buildYear/paintCode, the ormMaxLength sub-rules on vehicle.rego and
      // customer.companyName) are intentionally excluded so ORM validation can
      // never block normal Save/autosave. ORM rules are enforced only by the
      // ORM submit gate in QuoteOrm.vue (Send Quote / Send Tax Invoice).
      const baseEntityError =
        this.$v.entity.quoteId.$error ||
        this.$v.entity.vehicleId.$error ||
        this.$v.entity.insurerId.$error ||
        this.$v.entity.customerId.$error ||
        this.$v.entity.quoter.$error ||
        this.$v.entity.authorisedDate.$error ||
        this.$v.entity.labours.$anyError ||
        this.$v.entity.others.$anyError ||
        this.$v.entity.parts.$anyError ||
        this.$v.entity.opgs.$anyError ||
        this.$v.entity.miscs.$anyError ||
        this.$v.entity.sublets.$anyError ||
        this.$v.entity.invoices.$anyError ||
        (this.$v.entity.claimNo.$dirty && !this.$v.entity.claimNo.required)

      // Generic data-integrity rule for ALL quotes (not ORM-specific): job
      // start must not be after job end. Evaluated directly from entity data
      // and decoupled from the ORM jobStart/jobEnd validators so a non-ORM
      // quote still cannot be saved with the dates reversed (parity with
      // pre-change behaviour), without pulling ORM-only validation back into
      // the Save gate or touching/dirtying the ORM validators.
      const jobDatesOutOfOrder =
        !!(this.entity && this.entity.jobStart && this.entity.jobEnd) &&
        this.entity.jobStart > this.entity.jobEnd

      return (
        baseEntityError ||
        jobDatesOutOfOrder ||

        (this.$v.vehicle.rego.$dirty && !this.$v.vehicle.rego.required) ||
        this.$v.vehicle.model.$error ||
        this.$v.vehicle.bodyId.$error ||
        this.$v.vehicle.paintGroup.$error ||

        (this.$v.customer.companyName.$dirty &&
          (!this.$v.customer.companyName.required ||
            !this.$v.customer.companyName.isNotWhitespaceOnly)) ||
        this.$v.customer.firstname.$error ||
        this.$v.customer.lastname.$error ||
        this.$v.customer.emails.$error ||
        this.$v.customer.contacts.$error ||

        this.$v.insurer.name.$error
      )
    },
    invoice() {
      return this.entity.invoices.find((i) => !i.isNew && !i.deleted && i.invoiceType === InvoiceTypes.Quote)
    },
    excessInvoice() {
      return this.entity.invoices.find((i) => !i.isNew && !i.deleted && i.invoiceType === InvoiceTypes.Excess)
    },
    ocInvoice() {
      return this.entity.invoices.find((i) => !i.isNew && !i.deleted && i.invoiceType === InvoiceTypes.OwnerContribution)
    },
    isInvoiced() {
      return this.entity && this.entity.invoices && this.entity.invoices.length > 0
    },
    isNtar() {
      if (this.entity) {
        return (
          this.entity.labourType === LabourTimeTypes.NTAR || this.entity.labourType === LabourTimeTypes.LTAR || this.entity.labourType === LabourTimeTypes.eMTA
        )
      }
    },
    isEmta() {
      return this.entity.labourType === LabourTimeTypes.eMTA
    },
    isRacq() {
      return this.entity.labourType === LabourTimeTypes.RACQ
    },
    deleteQuoteMessage() {
      const quoteRef = `${this.entity.prefix}${this.entity.quoteNo}${this.entity.suffix}`
      if (this.entity.subQuoteNo === 0) {
        if (this.entity.subQuoteNos.length === 1) {
          return quoteRef
        }
        return `${quoteRef} and all supplementary quotes`
      } else if (this.entity.subQuoteNo > 0) {
        return `${quoteRef}/${this.entity.subQuoteNo}`
      }
      return quoteRef
    },
    deleteQuoteToastMessage() {
      if (!this.entity) return ''
      // Keep existing main-quote message as-is, but prefix supplementary quotes.
      return this.entity.subQuoteNo > 0 ? `Supplementary Quote ${this.deleteQuoteMessage}` : this.deleteQuoteMessage
    },
    insurerDefaultEmail() {
      const defaultEmail = this.quoteInsurer.emails.find((e) => e.isDefault)
      if (defaultEmail) {
        return defaultEmail.address
      } else {
        return ''
      }
    },
    showNewAdditional() {
      if (this.entity && this.entity.isAssessmentEnabled) {
        return false
      }
      if (this.entity && this.entity.isPnet === true && this.entity.audatex === null && this.entity.pnet !== null) {
        if (this.entity.pnet.authorityNo !== null && this.entity.pnet.authorityNo !== '') return true
        else return false
      } else {
        return (
          this.entity &&
          ((!this.entity.isAudaNet && !this.entity.isAudaBridge) ||
            ((this.audanetSetting.property4 === '1' ||
              this.audanetSetting.property4.toLowerCase() === 'true' ||
              this.audanetSetting.property4.toLowerCase() === '') &&
              (this.entity.isAudaNet || this.entity.isAudaBridge)))
        )
      }
    },
    // isAudanet() {
    //   return this.pnetSetting !== null && this.pnetSetting.property5 === '4.1'
    // },
    // isAudaBridge() {
    //   return this.entity.audatex !== null && this.entity.audatex.taskType === 'AudaBridge'
    // }
    uninterruptedView() {
      return this.$route.query.uninterruptedview === 'true'
    },
    canChangeReadOnly() {
      return this.$userInfo.isSupportUser || this.$userInfo.isCustomerAdministrator
    },
    hasUnsavedQuoteChanges() {
      if (this.snapshotDiff) return true
      // Only trust `isDiffChanged` while autosave is running: the entity watcher that clears it
      // is gated on `!entity.readOnly`, so locking the quote leaves it stuck true.
      return this.autoSaveActiveForQuote && Boolean(this.autoSaveStatus.isDiffChanged)
    },
    isQuoteSaveInProgress() {
      return Boolean(this.isSaving || this.autoSaveStatus.isSaving || this.headerAutosaveInFlight)
    },
    showQuoteActionButton() {
      // FQ-3037: deliberately not gated on `entity.readOnly`. Integrations (EstImage, PNET)
      // lock a quote as soon as an authority is loaded, and FQ-2955's lock gate then hid
      // New Additional Quote / Copy Quote / Export Quote — none of which edit this quote —
      // forcing users to unlock before starting a supplementary. Unpersisted state hides them
      // instead: all three read the quote server-side or navigate away from it.
      return (
        this.entity &&
        !this.entity.isNew &&
        !this.hasUnsavedQuoteChanges &&
        !this.isQuoteSaveInProgress &&
        !this.uninterruptedView &&
        !(this.$route.name === QuoteRoutes.QuotePartsControl.name) &&
        !(this.$route.name === QuoteRoutes.QuotePriceParts.name)
      )
    },
    canViewPricePartsMsg() {
      return (
        this.$userInfo.isSupportUser &&
        this.entity &&
        this.entity.parts.filter((p) => p.partStatus == 'Imp' || p.partStatus == 'Exp' || p.partStatus == 'Pord').length > 0
      )
    },
    quoteNoRef() {
      return `${this.entity.prefix}${this.entity.quoteNo}${this.entity.suffix}`
    },
    isRepx() {
      return this.entity && !!this.entity.repx
    },
    showLock() {
      if (!this.entity || this.entity.isNew) {
        return false
      }
      if (this.entity.isAssessmentEnabled) {
        // Show unlock button for locked quotes, hide for unlocked quotes
        return this.entity.readOnly
      }
      return true
    },
    isQuoteCancelledByInsurer() {
      if (this.entity.estimage) {
        return this.entity.estimage.quoteStatus === 'Cancelled'
      } else if (this.entity.orm) {
        //Quote_Job_Cancelled = 80
        return this.entity.orm.quoteStatusID === 80
      } else if (this.entity.pnet) {
        return this.entity.pnet.quoteStatusID === 60
      } else if (this.entity.audatex) {
        return this.entity.audatex.businessStatusText === 'Cancelled'
      }
    },
    showQuoteTemplate() {
      return this.entity && !this.entity.isNew && !this.entity.deleted && !this.entity.readOnly && this.$route.name === QuoteRoutes.QuoteBuilder.name
    },
    isQuoteBuilder() {
      return this.$route.name === QuoteRoutes.QuoteBuilder.name
    },
    isQuoteEditable() {
      //for orm quote with invoice submitted and assessment enabled, make it read only
      var quoteEditable = this.entity && !this.entity.isNew && !this.entity.deleted && !this.entity.readOnly
      // console.log('quoteEditable', quoteEditable, 'ormEditable', ormEditable)
      return quoteEditable && this.isOrmEditedQuote
    },
    isOrmEditedQuote() {
      var ormEditable = (this.entity && this.entity.orm && this.entity.orm.quoteStatusId === OrmQuoteStatusTypes.QuoteInvoiceSubmitted
        && this.entity.isAssessmentEnabled) ? false : true
      return ormEditable
    },
    hasFlexiShopIntegration() {
      return this.planningSetting && this.planningSetting.password
    },
    // jobNSubJobStageCompositeKey() {
    //   if (this.entity) {
    //     let jobStage = this.entity.jobStage
    //     if (jobStage) {
    //       let subJobStage = this.entity.subJobStage || ''
    //       return jobStage + '|' + subJobStage
    //     }
    //   }
    //   return ''
    // },
    jobNSubJobStageCompositeName() {
      // if (this.entity.isNew) {
      //   return '-'
      // }
      if (this.innerJobNSubJobStageCompositeKey) {
        if (this.jobNSubJobStages && Array.isArray(this.jobNSubJobStages)) {
          const jobNSubJobStage = this.jobNSubJobStages.find(j => j.compositeKey === this.innerJobNSubJobStageCompositeKey)
          if (jobNSubJobStage) {
            return jobNSubJobStage.compositeName
          }
        }
        if (this.jobStages && Array.isArray(this.jobStages)) {
          const jobStageKey = this.innerJobNSubJobStageCompositeKey.split('|')[0]
          const jobStage = this.jobStages.find(j => j.stage == jobStageKey)
          if (jobStage) {
            return jobStage.description
          }
        }
      }
      return ''
    },
    isAuthorised() {
      return this.entity && !this.entity.isNew && this.entity.authorisedBy
    },
    jobNSubJobStagesOptions() {
      if (!this.jobNSubJobStages) return []
      const isDisableParentWithSub = !!this.isRepx
      const groupedStages = {}

      // Group job stages and sub job stages
      this.jobNSubJobStages.forEach((option) => {
        const jobStageId = option.jobStageId
        const jobStageName = option.jobStageName

        if (!groupedStages[jobStageId]) {
          // Get sort key from jobStages array
          const jobStageInfo = this.jobStages ? this.jobStages.find(js => js.stage === jobStageId) : null
          const jobStageSortKey = jobStageInfo ? jobStageInfo.sortKey : 999

          groupedStages[jobStageId] = {
            jobStageId,
            jobStageName,
            jobStageSortKey: jobStageSortKey,
            mainStage: {
              compositeKey: `${jobStageId}|`,
              compositeName: jobStageName,
              disabled: false
            },
            subStages: []
          }
        }

        // If this option has a sub job stage, add it to the subStages array
        if (option.subJobStageId && option.subJobStageId !== '') {
          groupedStages[jobStageId].subStages.push(option)
          // If there are sub stages, disable the parent stage if needed
          if (isDisableParentWithSub) {
            groupedStages[jobStageId].mainStage.disabled = true
          }
        }
      })

      // Convert to array and sort by jobStageSortKey
      const sortedGroups = Object.values(groupedStages).sort((a, b) => {
        return (a.jobStageSortKey || 999) - (b.jobStageSortKey || 999)
      })

      // Sort sub stages within each group by sortKey
      sortedGroups.forEach(group => {
        group.subStages.sort((a, b) => {
          return (a.sortKey || 999) - (b.sortKey || 999)
        })
      })

      return sortedGroups
    },
    customerAndVehicleMakeModelMaxLength() {
      if (this.isScreenBelow(this.BULMA_BREAKPOINTS.FULLHD)) {
        return 0
      } else if (this.isScreenBelow(this.BULMA_BREAKPOINTS.XXL)) {
        return 10
      } else if (this.isScreenAbove(this.BULMA_BREAKPOINTS.XXL)) {
        return 20
      }
    },
    isNewCustomerPrompt() {
      const customerDiff = DeepDiff.diff(this.customer, this.initialQuoteCustomer)
      const isPerson = this.currentCustomerSnapshot && this.currentCustomerSnapshot.isPerson

      if (customerDiff) {
        const paths = customerDiff.map((d) => d.path).flat()
        let prompt = paths.includes('firstname') || paths.includes('lastname') || paths.includes('phones')
        if (!isPerson) {
          prompt = paths.includes('companyName')
        }
        return prompt
      }
      return false
    },
    isMainQuote() {
      return this.entity && this.entity.subQuoteNo === 0
    }
  },
  watch: {
    'entity.labours': {
      handler: function (newVal, oldVal) {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.paintTotal = roundAwayFromZero(this.paintTotal)
        this.entity.rrTotal = roundAwayFromZero(this.rrTotal)
        this.entity.repairTotal = roundAwayFromZero(this.repairTotal)
        this.entity.rwaTotal = roundAwayFromZero(this.rwaTotal)
        this.entity.labourTotal = roundAwayFromZero(this.labourTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        this.scheduleItemsSave()
      },
      deep: true
    },
    'entity.others': {
      handler: function () {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.cdTotal = roundAwayFromZero(this.cdTotal)
        this.entity.crushTotal = roundAwayFromZero(this.crushTotal)
        this.entity.mechTotal = roundAwayFromZero(this.mechTotal)
        this.entity.fgTotal = roundAwayFromZero(this.fgTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        this.scheduleItemsSave()
      },
      deep: true
    },
    'entity.parts': {
      handler: function () {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.partTotal = roundAwayFromZero(this.partTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        this.scheduleItemsSave()
      },
      deep: true
    },
    'entity.opgs': {
      handler: function () {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.opgTotal = roundAwayFromZero(this.opgTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        // opgs are not part of the managed item set, so no save is scheduled here.
      },
      deep: true
    },
    'entity.miscs': {
      handler: function () {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.miscTotal = roundAwayFromZero(this.miscTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        this.scheduleItemsSave()
      },
      deep: true
    },
    'entity.sublets': {
      handler: function () {
        const derivedGuard = this.getDerivedItemGuard()
        this.entity.sublTotal = roundAwayFromZero(this.subletTotal)
        if (derivedGuard.shouldSkipWatcher() || this._isAutosaveRefreshing) {
          return
        }
        this.scheduleItemsSave()
      },
      deep: true
    },
    entity: {
      handler: function (newVal, oldVal) {
        // Skip snapshot update during autosave entity refresh — saveSnapshot is called
        // explicitly by debouncedEntityRefresh after the entity is fully reconstructed.
        if (!this._isAutosaveRefreshing) {
          if (this.$route.name === QuoteRoutes.QuoteBuilder.name) {
            // On QuoteBuilder, batch rapid snapshot updates — see _throttledSnapshotUpdate below.
            this._throttledSnapshotUpdate()
          } else {
            // On other quote routes, update synchronously so the entity watcher's
            // DeepDiff.diff(baseSnapshot, currentSnapshot) check sees the latest state
            // and can trigger autoSaveQuote correctly.
            this.saveSnapshot(_cloneDeep(this.entity))
          }
        }
        if (!oldVal) return
        const keysToWatch = ['totalExGst', 'excess', 'ownersContribution', 'discount', 'excessWithGst']
        const hasChanged = keysToWatch.some((key) => newVal[key] !== oldVal[key])
        if (hasChanged) this.calculateTotalPayableIncGst()

        // trigger auto save on the entity, if not in quote items page,
        // as the quote items page will auto save the entity lite version
        if (this.$route.name !== QuoteRoutes.QuoteBuilder.name) {
          // if the quote is not new, then auto save the quote
          if (!this.entity.isNew && !this.entity.readOnly && !this.isLoading) {
            const quoteDiff = DeepDiff.diff(this.baseSnapshot, this.currentSnapshot)
            if (!quoteDiff) {
              if (!this.hasPendingAutoSaveDiffs()) {
                // Deliberately does not clear `isSaving`: this watcher runs before the render,
                // so clearing it here wiped the spinner for a save already in flight (unlock).
                this.setAutoSaveState({ isEditing: false })
              }
              return
            }
            this.setAutoSaveState({ isEditing: true })
            // Rates & Markups saves on field blur via QuoteRatesMarkups.vue (handleFieldBlur/handleRateBlur).
            // Annotations save on field blur via QuoteAnnotations.vue (handleAnnotationBlur).
            // All other non-builder routes (e.g. header panels) save on panel blur via queueHeaderAutosave.
          }
        }
      },
      deep: true
    },
    'entity.subQuoteNo': {
      handler: async function (newVal, oldVal) {
        await this.getMainQuoteEntity()
        if (this.entityMainQuote && this.entity.subQuoteNo > 0) {
          // update excessWithGst in the additional quote to match the value in the main quote
          this.entity.excessWithGst = this.entityMainQuote.excessWithGst
        }
      }
    },
    labourTotal(newVal, oldVal) {
      // console.log(this.previousQuoteId, newVal, oldVal, (newVal && !oldVal), (!newVal && oldVal))
      if (this.previousQuoteId !== '' && this.previousQuoteId !== this.entity.quoteId) {
        return
      }
      // if ((newVal && !oldVal) || (!newVal && oldVal)) {
      //   console.log('labourTotal return')
      //   return
      // }
      if (!this.entity.readOnly && this.isRacq && !isNaN(oldVal)) {
        // RACQ Consumables percentage
        this.addUpdateRacqConsumable()
        this.addUpdateRepairPanelConsumable()
        this.addUpdatePaintConsumable()
        this.addUpdatePaintMaterial()
        this.addUpdateSetupColourMatch1()

        // just for paint items with OPG code
        // if (this.entity.labours.some((l) => l.opgCode !== null && l.opgCode !== '')) {
        this.addUpdateOpgPaintMaterials()
        this.addUpdateSetupColourMatch2()
        // }
        this.addUpdateM3PlusAllowances()

        this.showToast('NTAR consumables & paint material items updated', 'success', 'bottom')
        this.scheduleItemsSave()
      } else if (!this.entity.readOnly && this.isNtar && !isNaN(oldVal)) {
        // NTAR Consumables
        this.addUpdateRepairPanelConsumable()
        this.addUpdatePaintConsumable()
        this.addUpdatePaintMaterial()
        this.addUpdateSetupColourMatch1()
        this.addUpdateOpgPaintMaterials()
        this.addUpdateSetupColourMatch2()
        this.addUpdateM3PlusAllowances()
        this.showToast('NTAR consumables & paint material items updated', 'success', 'bottom')
        this.scheduleItemsSave()
      }
    },
    opgTotal(newVal, oldVal) {
      // console.log('opgTotal', newVal, oldVal)
      if (this.previousQuoteId !== '' && this.previousQuoteId !== this.entity.quoteId) {
        return
      }
      // if ((newVal && !oldVal) || (!newVal && oldVal)) {
      //   return
      // }
      if (!this.entity.readOnly && this.isRacq && !isNaN(oldVal)) {
        // RACQ Consumables percentage
        this.addUpdateRacqConsumable()
        this.scheduleItemsSave()
      } else if (!this.entity.readOnly && this.isNtar && !isNaN(oldVal)) {
        // console.log('opgTotal isNtar')
        this.addUpdatePaintConsumable()
        this.addUpdatePaintMaterial()
        this.addUpdateSetupColourMatch1()
        this.addUpdateOpgPaintMaterials()
        this.addUpdateSetupColourMatch2()
        this.addUpdateM3PlusAllowances()
        this.showToast('NTAR consumables & paint material items updated', 'success', 'bottom')
        this.scheduleItemsSave()
      }
    },
    weldHourTotal(newVal, oldVal) {
      if (this.previousQuoteId !== '' && this.previousQuoteId !== this.entity.quoteId) {
        return
      }
      // if ((newVal && !oldVal) || (!newVal && oldVal)) {
      //   return
      // }
      if (!this.entity.readOnly && (this.isEmta || this.isNtar) && !isNaN(oldVal)) {
        // eMTA R&R Welded Allowances
        this.addUpdateWeldAllowance()
        this.scheduleItemsSave()
      }
    },
    totalExGst(newVal) {
      if (this.entity && !this.readOnlyView) {
        this.entity.totalExGst = newVal
      }
    },
    totalIncGst(newVal) {
      if (this.entity && !this.readOnlyView) {
        this.entity.totalIncGst = newVal
      }
    },
    showNewAdditional(newVal) {
      if (newVal) {
        this.fabActions.splice(1, 0, {
          name: 'newAdditional',
          icon: 'plus-outline',
          color: '#c14747',
          tooltip: 'New Additional'
        })
      } else {
        this.fabActions = this.fabActions.filter((fabAction) => fabAction.name !== 'newAdditional')
      }
    },
    // showNewAdditional(newVal) {
    //   if (newVal) {
    //     this.fabActions.splice(1, 0, {
    //       name: 'newAdditional',
    //       icon: 'plus-outline',
    //       color: '#c14747',
    //       tooltip: 'New Additional'
    //     })
    //   } else {
    //     this.fabActions = this.fabActions.filter((fabAction) => fabAction.name !== 'newAdditional')
    //   }
    // },
    vehicle: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.saveVehicleSnapshot(this.vehicle)
          if (this.suppressHeaderAutosave) {
            // During refresh, just keep the baseline aligned.
            this.headerAutosaveBaseline.vehicle = _cloneDeep(this.vehicle)
            return
          }

        }
      },
      deep: true
    },
    customer: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.saveCustomerSnapshot(this.customer)
          this.vehicle.customer = {
            key: this.customer.id,
            value: this.customer.fullname
          }
          if (this.suppressHeaderAutosave) {
            // During refresh, just keep the baseline aligned.
            this.headerAutosaveBaseline.customer = _cloneDeep(this.customer)
            return
          }
        }
      },
      deep: true
    },
    insurer: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.saveInsurerSnapshot(this.insurer)
          if (this.suppressHeaderAutosave) {
            // During refresh, just keep the baseline aligned.
            this.headerAutosaveBaseline.insurer = _cloneDeep(this.insurer)
            return
          }
        }
      },
      deep: true
    },
    isNtar(newVal) {
      if (this.entity && this.isNtar) {
        this.getNtarLoadingItems()
        this.getNtarOtherLoadingItems()
        this.getNtarLoadingValues()
      }
    },
    // change price parts return route based on if the user is in QuotePartsControl or QuoteSelections
    $route(to, from) {
      if (to.name === QuoteRoutes.QuotePartsControl.name) {
        this.pricePartsReturnRoute = QuoteRoutes.QuotePartsControl.name
      } else if (to.name === QuoteRoutes.QuoteBuilder.name) {
        this.pricePartsReturnRoute = QuoteRoutes.QuoteBuilder.name
      }
    },
    selectedMenu(newVal) {
      if (this.$refs.routerView && this.$refs.routerView.handleToggleAvaliableItems) {
        if (newVal === QUOTE_BUILDER_SIDEBAR_MENU_MODES.MANUAL) {
          this.$refs.routerView.showQuoteItem()
        } else if (newVal === QUOTE_BUILDER_SIDEBAR_MENU_MODES.TEMPLATES) {
          this.$refs.routerView.showTemplates()
        } else if (newVal === QUOTE_BUILDER_SIDEBAR_MENU_MODES.VEHICLE) {
          this.$refs.routerView.showQuoteBuilder()
        }
      }
    },
    'entity.jobStage'(newVal, oldVal) {
      this.setInnerJobNSubJobStageCompositeKey()
    }
  },
  // errorCaptured(err, vm, info) {
  //   console.log(err)
  // },
  async created() {
    // Initialize AutoSave Helper
    const autoSaveHelper = createAutoSaveHelper(this)
    this.autoSaveHelper = autoSaveHelper

    // Bind helper methods to this instance (overriding potential mixin conflicts or placeholders)
    this.autoSaveQuote = autoSaveHelper.autoSaveQuote
    this.autoUpdateQuoteHeader = autoSaveHelper.autoUpdateQuoteHeader
    this.scheduleItemsSave = autoSaveHelper.scheduleItemsSave
    this.runItemsSave = autoSaveHelper.runItemsSave
    this.hasPendingItemsSave = autoSaveHelper.hasPendingItemsSave
    this.stopQuoteItemsEditDeferMonitor = autoSaveHelper.stopQuoteItemsEditDeferMonitor
    this.queueHeaderAutosave = autoSaveHelper.queueHeaderAutosave
    this.hasPendingAutoSaveWork = autoSaveHelper.hasPendingAutoSaveWork
    this.hasPendingAutoSaveDiffs = autoSaveHelper.hasPendingAutoSaveDiffs
    this.registerAutoSaveFailure = autoSaveHelper.registerAutoSaveFailure
    this.resetAutoSaveFailures = autoSaveHelper.resetAutoSaveFailures
    this.setAutoSaveState = autoSaveHelper.setAutoSaveState
    this.isValidItemAutoSave = autoSaveHelper.isValidItemAutoSave
    this.deleteEmptyLineItems = autoSaveHelper.deleteEmptyLineItems
    this.saveQuoteAfterHeaderChangeNow = autoSaveHelper.saveQuoteAfterHeaderChangeNow
    this.hasHeaderQuoteIdChanges = autoSaveHelper.hasHeaderQuoteIdChanges
    this.autoSave = autoSaveHelper.autoSave
    this.saveQuoteAndContinue = autoSaveHelper.saveQuoteAndContinue
    this.hasEmptyLineItems = autoSaveHelper.hasEmptyLineItems
    this.handleNavigationWarningConfirm = autoSaveHelper.handleNavigationWarningConfirm
    this.handleNavigationWarningCancel = autoSaveHelper.handleNavigationWarningCancel
    this.getExpandedQuoteItemId = autoSaveHelper.getExpandedQuoteItemId
    this.getFocusedItemInfo = autoSaveHelper.getFocusedItemInfo
    this.findItemIdByLineAndType = autoSaveHelper.findItemIdByLineAndType
    this.saveLiteHeaderNow = autoSaveHelper.saveLiteHeaderNow
    this.saveJobStageNow = autoSaveHelper.saveJobStageNow
    this.saveReadOnlyNow = autoSaveHelper.saveReadOnlyNow
    this.debouncedSaveHeader = autoSaveHelper.debouncedSaveHeader
    this.debouncedEntityRefresh = autoSaveHelper.debouncedEntityRefresh

    // Non-reactive flag: set by debouncedEntityRefresh before replacing vm.entity so that
    // the entity watcher and item-array watchers can skip redundant work during refresh.
    this._isAutosaveRefreshing = false

    // Performance throttle — the entity watcher fires on every keystroke; running a full cloneDeep +
    // Vuex mutation + snapshotDiff recomputation (4× DeepDiff) on each one is too expensive.
    // This batches rapid changes into a single snapshot update via a 300ms trailing delay.
    this._throttledSnapshotUpdate = _debounce(() => {
      this.saveSnapshot(_cloneDeep(this.entity))
    }, 300)

    await this.getCompanyExternalSetting()
    this.getAudanetPnetSetting()
    // this.setupFabButtons()
    this.getStandardLabourItems()
    await this.getEntity()

    await this.getMainQuoteEntity()
    if (this.returnUrl) {
      this.persistQueries()
      this.replaceRoute(this.$route.params.quoteId)
    }
    this.getJobNSubJobStages()

    await this.loadButterflySelections()
    this.setInnerJobNSubJobStageCompositeKey()

    this.setInitialQuoteCustomer()

  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.EntityReload, async () => {
      await this.getEntity(true)
      this.$eventHub.$emit(EventHubTypes.EntityReloaded)
    })
    this.$eventHub.$on(`${EventHubTypes.ImageCountChanged}UpdateQuote`, () => {
      this.entity.modifiedDate = null
      this.save()
    })
    this.$eventHub.$on(EventHubTypes.ToggleSideMenu, this.handleToggleSideMenu)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    // Explicit save trigger for mutations the deep watchers can't catch (e.g. in-place sortNo).
    this.$eventHub.$on(EventHubTypes.AutoSaveQuoteItems, () => {
      this.$nextTick(() => this.scheduleItemsSave())
    })
    this.$eventHub.$on(EventHubTypes.AutoSaveRatesMarkupsStatus, async (status) => {
      this.setAutoSaveState(status)
      if (!status.isSaving && !status.isFailed) {
        await this.getLiteStoreItem(this.entity.quoteId)
        if (this.currentSnapshot?.modifiedDate) {
          this.entity.modifiedDate = this.currentSnapshot.modifiedDate
        }
        this.setBaseSnapshot(_cloneDeep(this.entity))
      }
    })
    this.$eventHub.$on(EventHubTypes.AutoSaveAnnotationsStatus, async (status) => {
      this.setAutoSaveState(status)
      if (!status.isSaving && !status.isFailed) {
        await this.getLiteStoreItem(this.entity.quoteId)
        if (this.currentSnapshot?.modifiedDate) {
          this.entity.modifiedDate = this.currentSnapshot.modifiedDate
        }
        this.setBaseSnapshot(_cloneDeep(this.entity))
      }
    })
  },
  beforeDestroy() {

    // Cancel any pending autosave operations
    if (this.autoUpdateQuoteHeader && typeof this.autoUpdateQuoteHeader.cancel === 'function') {
      this.autoUpdateQuoteHeader.cancel()
    }
    if (this.scheduleItemsSave && typeof this.scheduleItemsSave.cancel === 'function') {
      this.scheduleItemsSave.cancel()
    }
    if (this.debouncedSaveHeader && typeof this.debouncedSaveHeader.flush === 'function') {
      this.debouncedSaveHeader.flush()
    }
    if (this.debouncedEntityRefresh && typeof this.debouncedEntityRefresh.cancel === 'function') {
      this.debouncedEntityRefresh.cancel()
    }

    this.$eventHub.$off(EventHubTypes.EntityReload)
    if (_isEmpty(this.returnRoute)) {
      this.setReadOnlyView(false)
    }
    this.$eventHub.$off(`${EventHubTypes.ImageCountChanged}UpdateQuote`)
    this.$eventHub.$off(EventHubTypes.ToggleSideMenu, this.handleToggleSideMenu)
    this.$eventHub.$off(EventHubTypes.AutoSaveQuoteItems)
    this.$eventHub.$off(EventHubTypes.AutoSaveRatesMarkupsStatus)
    this.$eventHub.$off(EventHubTypes.AutoSaveAnnotationsStatus)

    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    if (this.stopQuoteItemsEditDeferMonitor) {
      this.stopQuoteItemsEditDeferMonitor()
    }
  },
  methods: {

    toggleAutoSave() {
      // Autosave is disabled
    },
    // Warn before unload while an items save is still pending/in-flight.
    handleBeforeUnload(e) {
      if (this.hasPendingItemsSave && this.hasPendingItemsSave()) {
        e.preventDefault()
        e.returnValue = ''
        return ''
      }
    },
    onRemarksSaveStateChange(isSaving) {
      if (this.setAutoSaveState) this.setAutoSaveState({ isSaving })
    },
    async onRemarksSaved() {
      await this.getLiteStoreItem(this.entity.quoteId)
      if (this.currentSnapshot?.modifiedDate) {
        this.entity.modifiedDate = this.currentSnapshot.modifiedDate
      }
      this.saveSnapshot(_cloneDeep(this.entity))
      this.setBaseSnapshot(_cloneDeep(this.entity))
      if (!this.hasPendingAutoSaveDiffs()) {
        this.setAutoSaveState({ isEditing: false })
      }
    },
    async handleManualSaveRequest() {
      try {
        Sentry.captureMessage('Manual save button clicked (autosave on)', {
          level: 'info',
          tags: { feature: 'autosave', action: 'manual_save_click' },
          extra: {
            autoSaveEnabled: this.autoSaveEnabled,
            isSaving: this.autoSaveStatus.isSaving,
            isEditing: this.autoSaveStatus.isEditing,
            unsavedChanges: this.autoSaveStatus.isDiffChanged,
            isFailed: this.autoSaveStatus.isFailed,
            failMessage: this.autoSaveStatus.failMessage,
            autoSaveFailureCount: this.autoSaveFailureCount,
            quoteSaveStatus: this.quoteSaveStatus,
            quoteId: this.entity && this.entity.quoteId,
            quoteNo: this.quoteNoRef,
            // Pending changes at the moment manual save was used (deep-diffs as JSON strings).
            // Tells us what autosave had not persisted yet.
            snapshotDiff: stringifyDiff(this.snapshotDiff),
            snapshotDiffCustomer: stringifyDiff(this.snapshotDiffCustomer),
            snapshotDiffVehicle: stringifyDiff(this.snapshotDiffVehicle),
            snapshotDiffInsurer: stringifyDiff(this.snapshotDiffInsurer)
          }
        })
      } catch (telemetryError) {
        console.error('Failed to report manual save to Sentry:', telemetryError)
      }

      if (this.autoSaveStatus.isSaving) return
      const saved = await this.save(false, true, false, true)
      if (saved) {
        this.resetAutoSaveFailures()
        this.setAutoSaveState({ isFailed: false, isEditing: false })
      }
    },
    getDerivedItemGuard() {
      return {
        shouldSkipWatcher: () => this.derivedItemUpdateDepth > 0,
        run: (callback) => {
          this.derivedItemUpdateDepth += 1
          try {
            return typeof callback === 'function' ? callback() : undefined
          } finally {
            this.derivedItemUpdateDepth = Math.max(0, this.derivedItemUpdateDepth - 1)
          }
        }
      }
    },
    async getSupplementaryQuotes() {
      this.supplementaryQuotes = await QuoteService.getSupplementaryQuoteTotals(this.$route.params.quoteId)
    },
    calculateTotalPayableIncGst() {
      const grandTotal =
        this.entity.subQuoteNos.length > 1
          ? this.calculateGrandTotal(
              this.entity.totalExGst,
              (this.supplementaryQuotes || []).map((q) => q.totalExGst)
            )
          : this.entity.totalExGst
      const excess = this.entity.excess ?? 0
      const discount = this.entity.discount ?? 0
      const invTotalExGst = !this.entity.excessWithGst ? grandTotal - discount : grandTotal - (excess + discount)
      const total = invTotalExGst * (this.entity.gstRate / 100 + 1)
      const ownerContributionWithGST = this.entity.ownersContribution * (this.entity.gstRate / 100 + 1)
      const totalPayableIncGst = this.entity.excessWithGst ? total - ownerContributionWithGST : total - this.entity.excess - ownerContributionWithGST
      return totalPayableIncGst
    },
    calculateGrandTotal(mainCategorytotal, supplementaryCategoryTotalsArray) {
      const suppCategoryTotal = supplementaryCategoryTotalsArray.reduce(function (total, suppTotal) {
        return total + suppTotal
      }, 0)
      return mainCategorytotal + suppCategoryTotal
    },
    handleToggleSideMenu(val) {
      this.showHorizontalMenu = !this.showHorizontalMenu
    },
    formatJobStage(value) {
      if (value.toLowerCase() === 'none') {
        return '-- Job Stage --'
      } else {
        return value
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
          .replace(/^./, function (str) {
            return str.toUpperCase()
          })
      }
    },
    displayJobStage(jobNSubJobStage) {
      const hasSubJobStage = !!jobNSubJobStage.subJobStageId
      let name = hasSubJobStage ? (jobNSubJobStage.subJobStageName || jobNSubJobStage.compositeName) : jobNSubJobStage.compositeName

      if (name.toLowerCase() === '' || name == null) {
        return hasSubJobStage ? '-- Sub Job Stage --' : '-- Job Stage --'
      } else {
        name = this.formatJobStage(name)
      }
      return hasSubJobStage ? `   ${name}` : name
    },
    async handleJobNSubJobStageChanged() {
      if (!this.innerJobNSubJobStageCompositeKey) return

      const [jobStageId, subJobStageId] = this.innerJobNSubJobStageCompositeKey.split('|')
      this.entity.jobStage = parseInt(jobStageId)
      this.entity.subJobStage = subJobStageId || ''
      await this.saveJobStageNow()
    },
    async getUnreadOrmMessageCount() {
      if (!this.entity.orm) return
      this.ormUnreadMessageCount = await OrmMessageService.unreadMessageCount(this.entity.quoteId)
    },
    // this function is called when the user changes the default paint group in the header
    updateQuoteItemsDefaultPaintGroup(val, oldVal) {
      const itemsToChange = this.entity.labours.filter(
        (l) => l.itemType === ItemCategoryTypes.PAINT && (l.opgCode == null || l.opgCode == '' || l.opgCode == oldVal)
      )
      // we get ids of items that are already authorised (paint items) and get their quoteItemId
      const authorisedItemsId = []
      const submittedItemsId = []
      this.entity.quoteAssessments.forEach((assessment) => {
        if (!!assessment?.isAuthorised && !!assessment?.authorisedAssessment?.assessmentQuoteItems?.length) {
          assessment.authorisedAssessment.assessmentQuoteItems.forEach((item) => {
            if (item.itemType === ItemCategoryTypes.PAINT && (item.opgCode == null || item.opgCode == '' || item.opgCode == oldVal)) {
              authorisedItemsId.push(item.quoteItemId)
            }
          })
        }

        if (!!assessment?.submittedAssessment?.assessmentQuoteItems?.length) {
          assessment.submittedAssessment.assessmentQuoteItems.forEach((item) => {
            submittedItemsId.push(item.quoteItemId)
          })
        }
      })
      itemsToChange.forEach((item) => {
        // if item is already authorised, do not change it
        if (!authorisedItemsId.includes(item.quoteItemId) && !submittedItemsId.includes(item.quoteItemId)) {
          item.opgCode = val
        }
      })

      this.$nextTick(() => {
        this.onOpgCodeChanged()
      })
    },
    onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          break
        case AppHeaderButtonTypes.Print:
          console.log(this.snapshotDiff)
          if (this.snapshotDiff) {
            this.$unSavedModal.open({
              skipDisabled: true,
              onSkipSave: () => {},
              onCancel: () => {},
              onSaveContinue: async () => {
                await this.save()
                this.onHeaderButtonClicked(AppHeaderButtonTypes.Print)
              }
            })
            return
          }

          if (this.$route.name === QuoteRoutes.QuoteInvoice.name) {
            // Print invoice
            if (this.invoice) {
              // print Malaysia invoice
              if (this.$company.info.countryCode === 'MY') {
                this.printMyInvoice()
              } else {
                this.isInvoicePrintOptionsActive = true
              }
            } else {
              // this.$toast.open({
              //   message: 'Nothing to print. Please create invoice first',
              //   type: 'is-danger'
              // })
              this.$notification.error('', 'Nothing to print. Please create invoice first')
            }
          } else if (this.$route.name === QuoteRoutes.QuoteExcessInvoice.name) {
            // Print excess invoice
            if (this.excessInvoice) {
              this.printExcessInvoice()
            } else {
              // this.$toast.open({
              //   message: 'Nothing to print. Please create excess invoice first',
              //   type: 'is-danger'
              // })
              this.$notification.error('', 'Nothing to print. Please create excess invoice first')
            }
            if (!this.entity.excessWithGst && this.ocInvoice) {
              this.printOcInvoice()
            }
          } else {
            this.isPrintOptionsActive = true
          }
          break
        case AppHeaderButtonTypes.Delete:
          this.isConfirmModalActive = true
          break
        case AppHeaderButtonTypes.Save:
          this.save()
          break
        case AppHeaderButtonTypes.Cancel:
          this.cancel()
          break
        case AppHeaderButtonTypes.Lock:
          this.toggleReadOnly()
          break
        case AppHeaderButtonTypes.PriceParts:
          this.viewPartsCheckRequest()
          break
        case AppHeaderButtonTypes.PreApplyQuoteTemplateCheck:
          this.checkBeforeQuoteTemplateApplication()
          break
        case AppHeaderButtonTypes.ApplyQuoteTemplate:
          this.applyQuoteTemplate()
          break
        case AppHeaderButtonTypes.Calendar:
          this.$router.push(BookingRoutes.CalendarView.path)
          break
        case AppHeaderButtonTypes.NewAdditionalQuote:
          this.newAdditional()
          break
        case AppHeaderButtonTypes.CopyQuote:
          this.showCopyQuoteModal()
          break
        case AppHeaderButtonTypes.ExportQuote:
          this.exportQuote()
          break
        case AppHeaderButtonTypes.Restore:
          this.restoreQuote()
          break
        case AppHeaderButtonTypes.EnableAssessmentHistory:
          this.toggleAssessmentHistory()
          break
      }
    },
    async restoreQuote() {
      const quoteRef = `${this.entity.prefix}${this.entity.quoteNo}${this.entity.suffix}` +
        (this.entity.subQuoteNo === 0 ? '' : `/${this.entity.subQuoteNo}`)
      try {
        const { data: exists } = await QuoteService.isQuoteNoExists(quoteRef)
        if (exists) {
          this.$notification.openNotificationWithType(
            'danger',
            'Restore Quote',
            `Cannot restore: an active quote with the same number "${quoteRef}" already exists.`
          )
          return
        }
      } catch (e) {
        console.log(e)
      }
      const isOrphanSuppRestore = this.entity.subQuoteNo > 0 && this.entityMainQuote && this.entityMainQuote.deleted
      const isMainRestore = this.entity.subQuoteNo === 0
      if (isOrphanSuppRestore || isMainRestore) {
        this.isRestoreAllConfirmModalActive = true
        return
      }
      this.entity.deleted = false
    },
    confirmRestoreAll(confirm) {
      this.isRestoreAllConfirmModalActive = false
      if (confirm) {
        this.entity.deleted = false
      }
    },
    toggleAssessmentHistory() {
      this.entity.isAssessmentEnabled = !this.entity.isAssessmentEnabled
      this.saveLiteHeaderNow()
      if (this.$route.name === QuoteRoutes.AuthoriseView.name) {
        if(!this.entity.isAssessmentEnabled) {
        this.$router.push({
          name: QuoteRoutes.QuoteHeader.name,
            params: { quoteId: this.$route.params.quoteId },
            query: this.$route.query
          })
        }
      }
    },
    checkBeforeQuoteTemplateApplication() {
      this.quoteTemplateDisabled = this.validateError
    },
    applyQuoteTemplate() {
      this.isQuoteTemplateModalActive = true
    },
    hideHeaderButtons(isHide) {
      this.isHeaderButtonHided = isHide
    },
    // targetQuoteId: pass the destination quote id when calling from a navigation guard —
    // inside beforeRouteUpdate the navigation is not yet confirmed, so this.$route still
    // points to the OLD route and must not be used to decide which quote to load.
    async getEntity(reset = false, silent = false, targetQuoteId = null) {
      if (!silent) this.$showSpinner()
      this.isLoading = true
      const routeQuoteId = targetQuoteId || this.$route.params.quoteId
      if (reset) {
        this.clearSessionStorage()
        this.clearSnapshots(routeQuoteId)
        this.clearHeaders()
        this.clearInvoiceState()
      }
      // Load when there is no cached snapshot, OR when the cached snapshot belongs to a
      // different quote than the one being routed to. The snapshot store is a single global
      // slot, so a stale snapshot from a previously-viewed quote (e.g. resurrected by a
      // late autosave/refresh) would otherwise be cloned here, showing the wrong quote.
      const snapshotMatchesRoute =
        this.currentSnapshot &&
        String(this.currentSnapshot.quoteId).toLowerCase() === String(routeQuoteId).toLowerCase()
      if (!snapshotMatchesRoute) {
        await this.getStoreItem(routeQuoteId)
      }
      this.entity = _cloneDeep(this.currentSnapshot)

      //Show update notificatin
      if (this.entity.doesQuoteAutoUpdated) {
        let updateSource = ''
        if (this.entity.audatex) {
          updateSource = 'AudaNet/AudaBridge'
        }
        this.$notification.openNotificationWithType('success', '', `Quote updated from ${updateSource}.`, 5000)
      }

      // Reset isCopyQuote to trigger unsaved changes modal
      if (this.entity.isCopyQuote) {
        const isCopyImages = this.entity.copyImageQuoteId !== Guid.empty()
        this.entity.isCopyQuote = false
        if (this.autoSaveActiveForQuote) {
          // With autosave on the copy is persisted automatically, so don't prompt to save.
          // Persist + fully reload (see saveCopiedQuoteWithAutosave) so all server-synced state
          // (real item ids, copied images, assessments) is correctly set.
          this.$notification.openNotificationWithType(
            'success',
            '',
            `Copy quote successful.${isCopyImages ? ' Images will appear shortly.' : ''}`,
            5000
          )
          // Defer to a macrotask so the persist+reload runs after this getEntity call returns,
          // avoiding re-entrancy into getEntity from within itself.
          setTimeout(() => this.saveCopiedQuoteWithAutosave(), 0)
        } else {
          this.$notification.openNotificationWithType(
            'success',
            '',
            `Copy quote successful. Please remember to save quote.${isCopyImages ? ' Images will appear after saving quote.' : ''}`,
            5000
          )
        }
      }

      if (this.isNtar || this.Emta) {
        this.getNtarLoadingItems()
        this.getNtarOtherLoadingItems()
        this.getNtarLoadingValues()
      }
      // this.setAudaNetLock(this.entity.isAudaNet && !this.$user.info.isSupportUser && !this.$user.info.isCustomerAdministrator)
      // if (!this.entity.isNew) {
      //   // Get and store vehicle in vuex store quotes/quoteVehicle
      //   this.getQuoteVehicle(this.entity.vehicleId)
      //   // Get and store vehicle in vuex store quotes/quoteCustomer
      //   this.getQuoteCustomer(this.entity.customerId)

      // this.$resetSpinner()

      await this.getQuoteAssests()

      if (!!this.entity.orm) {
        await this.getOrmUnreadPaymentAuthorisedMessage()
        this.getUnreadOrmMessageCount()
      }

      // ORM-specific validation must fire only when the user submits the quote
      // at the ORM page (Send Quote / Send Tax Invoice in QuoteOrm.vue). It is
      // intentionally NOT touched on load so opening an existing ORM quote does
      // not surface ORM errors or block normal Save/autosave.

      if (!silent) this.$resetSpinner()
      this.isLoading = false
    },
    async getOrmUnreadPaymentAuthorisedMessage() {
      try {
        const currentMessageNo = parseInt(this.entity.orm.messageNo, 10) || 0
        const expectedMessageNo = currentMessageNo + 1

        const messages = await OrmService.getMessages(
          this.entity.claimNo,
          this.entity.vehicleRego,
          MessageTypes.QML_PaymentAuthorised
        )

        if (!messages || messages.length === 0) {
          return
        }

        const latestMessage = [...messages].sort(
          (a, b) => b.ormMessageNo - a.ormMessageNo
        )[0]

        console.log('expectedMessageNo:', expectedMessageNo, latestMessage)
        if (latestMessage && expectedMessageNo === latestMessage.ormMessageNo && latestMessage.statusId === 30) {
          await OrmMessageService.loadMessage({
            messageId: latestMessage.messageId,
            messageTypeId: latestMessage.messageTypeId,
            quoteId: this.entity.quoteId
          })
          // Reload the page data to reflect the updated ORM status
          console.log('ORM message loaded successfully, refreshing entity data...')
          await this.getEntity(true)
          this.$notification?.success('ORM Message', 'Payment authorised message loaded successfully')
        }
      } catch (error) {
        console.error('Failed to load ORM payment authorised message:', error)
      }
    },
    async getQuoteAssests(isNew = false) {
      if (this.entity.isNew) {
        await Promise.all([this.getNewVehicle(), this.getNewCustomer(), this.getNewInsurer()])
        this.vehicle = _cloneDeep(this.currentVehicleSnapshot)
        this.customer = _cloneDeep(this.currentCustomerSnapshot)
        this.insurer = _cloneDeep(this.currentInsurerSnapshot)

        // Ensure IDs are linked if they were missing (and we generated new ones)
        if (!Guid.validGuid(this.entity.vehicleId) && this.vehicle) {
          this.entity.vehicleId = this.vehicle.id
        }
        if (!Guid.validGuid(this.entity.customerId) && this.customer) {
          this.entity.customerId = this.customer.id
        }

        // Establish baseline for header autosave diffs
        this.headerAutosaveBaseline.vehicle = _cloneDeep(this.vehicle)
        this.headerAutosaveBaseline.customer = _cloneDeep(this.customer)
        this.headerAutosaveBaseline.insurer = _cloneDeep(this.insurer)

        this.entity.vehicleId = this.quoteVehicle.id
        this.entity.customerId = this.quoteCustomer.id
        this.entity.insurerId = this.quoteInsurer.insurerId
        this.entity.driveable = this.$company.setting.driveableDefault
        this.entity.jobStage = JobStageTypes.ToBeQuoted
        this.entity.quoteAssessments = []
      } else {
        const promises = []
        if (Guid.validGuid(this.entity.vehicleId)) {
          // Get and store vehicle in vuex store quotes/quoteVehicle
          promises.splice(promises.length, 1, this.getQuoteVehicle({ id: this.entity.vehicleId, refresh: true }))
          // this.getQuoteVehicle({ id: this.entity.vehicleId, refresh: reset })
        } else {
          promises.splice(promises.length, 1, this.getNewVehicle())
        }
        if (Guid.validGuid(this.entity.customerId)) {
          // Get and store vehicle in vuex store quotes/quoteVehicle
          promises.splice(promises.length, 1, this.getQuoteCustomer({ id: this.entity.customerId, refresh: true }))
          // this.getQuoteCustomer({ id: this.entity.customerId, refresh: reset })
        } else {
          promises.splice(promises.length, 1, this.getNewCustomer())
        }
        if (Guid.validGuid(this.entity.insurerId)) {
          promises.splice(promises.length, 1, this.getQuoteInsurer({ id: this.entity.insurerId, refresh: true }))
        } else{
        //  the insurerId is not valid guid, get a new insurer, when quote is made using PWA app and insurer is left blank.
          promises.splice(promises.length, 1, this.getNewInsurer())
        }
        await Promise.all(promises)
        console.log('getEntity Promise.all')
        this.vehicle = _cloneDeep(this.currentVehicleSnapshot)
        if (this.vehicle) this.vehicle.isNew = false
        this.customer = _cloneDeep(this.currentCustomerSnapshot)
        this.vehicle.customer = {
          key: this.customer.id,
          value: this.customer.fullname
        }
        this.insurer = _cloneDeep(this.currentInsurerSnapshot)

        // The customer link + isNew normalization above is applied to the live vehicle
        // only (which the watcher mirrors into currentVehicleSnapshot). Quotes created
        // from the ORM feed store the vehicle without this customer link, so the baseline
        // (quoteVehicle) would otherwise diverge and the quote shows unsaved changes on
        // load. Realign the baseline to the normalized vehicle so the display-only link
        // is not counted as an edit; genuine user edits afterwards still register.
        this.setQuoteVehicle(_cloneDeep(this.vehicle))

        // Ensure IDs are linked if they were missing (and we generated new ones)
        if (!Guid.validGuid(this.entity.vehicleId) && this.vehicle) {
          this.entity.vehicleId = this.vehicle.id
        }
        if (!Guid.validGuid(this.entity.customerId) && this.customer) {
          this.entity.customerId = this.customer.id
        }

        // Establish baseline for header autosave diffs
        this.headerAutosaveBaseline.vehicle = _cloneDeep(this.vehicle)
        this.headerAutosaveBaseline.customer = _cloneDeep(this.customer)
        this.headerAutosaveBaseline.insurer = _cloneDeep(this.insurer)

        this.setInitialQuoteCustomer()
        console.log(`${this.$options.name} - ${this.vehicle.modifiedDate}`)
        console.log(`${this.$options.name} - ${this.customer.modifiedDate}`)
        console.log(`${this.$options.name} - ${this.insurer?.modifiedDate}`)
      }
    },
    async getMainQuoteEntity() {
      if (this.entity && this.entity.subQuoteNo > 0) {
        this.entityMainQuote = await QuoteService.getMainQuoteEntity(`${this.entity.prefix}${this.entity.quoteNo}${this.entity.suffix}`)
      } else {
        this.entityMainQuote = null
      }
    },
     async saveQuoteAssets(isNew = false) {
      let promises = []
      try {
        if (this.customer.isNew) {
          // promises.splice(promises.length, 1, CustomerService.postCustomer(this.customer))
          console.log(this.customer)
          await CustomerService.postCustomer(this.customer)
          this.setCustomerState(false)
          this.setInitialQuoteCustomer()
          this.$eventHub.$emit(EventHubTypes.EntitySaved)
        } else if (this.snapshotDiffCustomer) {
          // promises.splice(promises.length, 1, CustomerService.putCustomer(this.customer, this.snapshotDiffCustomer))
          await CustomerService.putCustomer(this.customer, this.snapshotDiffCustomer)
        }

        if (this.vehicle.isNew) {
          promises.splice(promises.length, 1, VehicleService.postEntity(this.vehicle))
        } else if (this.snapshotDiffVehicle) {
          this.vehicle.excludeQuoteId = this.entity.quoteId
          promises.splice(promises.length, 1, VehicleService.putEntity(this.vehicle, this.snapshotDiffVehicle, true))
        }

        if (this.insurer.isNew) {
          promises.splice(promises.length, 1, InsurerService.postInsurer(this.insurer))
        } else if (this.snapshotDiffInsurer) {
          promises.splice(promises.length, 1, InsurerService.putInsurer(this.insurer, this.snapshotDiffInsurer, true))
        }

        if (promises.length > 0) {
          await Promise.all(promises).then(() => {
            this.vehicle.isNew = false
            this.insurer.isNew = false
          })
        }
        return true
      }
      catch (e) {
        this.customerSaveAction = ''
        const msg = e.response?.data?.message || e.message
        this.$notification.openNotificationWithType('danger', 'Quote Assets', msg)
        return false
      }
    },

    async save(isDelete = false, showNoChangeMessage = true, routeToPriceParts = false, showSpinner = true) {
      // check and delete empty line items
      // that were just added
      this.purgeNewEmptyLineItems()

      const title = 'Repairer Quote'

      if (this.validateError) {
        // this.logValidationErrors()
        this.$notification.openNotificationWithType('danger', title, 'Validation errors. Please fix before saving')
        this.showItemsValidationErrors()
        return false
      }

      try {
        /// part of auto save
        this.isSaving = true
        showSpinner ? this.$showSpinner('Saving...') : null

        let response
        this.saveSnapshot(_cloneDeep(this.entity))
        const isCustomerInfoChanged = await this.triggerIsNewOwnerPrompt()

        if((!this.vehicle.isNew || !this.customer.isNew) && isCustomerInfoChanged ){
          this.isCustomerCreateModifyModalActive = true
          return false
        }
        // else if(this.vehicle.isNew && !this.customer.isNew && isCustomerInfoChanged){
        //   this.customerSaveAction = 'modify'
        //   this.isCustomerCreateModifyModalActive = true
        //   return false
        // }
        // this.$showSpinner('Saving...')
        await this.assignLineNumbers()
        if (this.entity.isNew) {
          this.isCustomerCreateModifyModalActive = false
          const isSuccess = await this.saveQuoteAssets(this.entity.isNew)
          if (!isSuccess) {
            return false
          }
          response = await QuoteService.postEntity(this.entity)
        } else if (this.snapshotDiff) {
          const isSuccess = await this.saveQuoteAssets()
          if (!isSuccess) {
            return false
          }
          response = await QuoteService.putEntity(_cloneDeep(this.entity), this.snapshotDiff)
        } else if (showNoChangeMessage) {
          // this.$toast.open('warning', 'No changes. Not saved')
          this.$notification.warning('', 'No changes. Not saved')
        }
        this.isSaving = false
        showSpinner ? this.$hideSpinner() : null
        if (this.isSaveContinue) {
          // this.$toast.open('success', isDelete ? `${this.quoteNoRef} deleted` : `Quote ${this.quoteNoRef} saved`)
          if (!this._suppressSaveToast) this.$notification.success('', isDelete ? `${this.deleteQuoteToastMessage} deleted` : `Quote ${this.quoteNoRef} saved`)
        } else if (response && response.status === HttpStatus.NO_CONTENT) {
          await this.getEntity(true)
          // this.$toast.open('success', isDelete ? `${this.quoteNoRef} deleted` : `Quote ${this.quoteNoRef} saved`)
          if (!this._suppressSaveToast) this.$notification.success('', isDelete ? `${this.deleteQuoteToastMessage} deleted` : `Quote ${this.quoteNoRef} saved`)
        } else if (response && response.status === HttpStatus.CREATED) {
          await this.getEntity(true)
          // this.$toast.open('success', `New quote ${this.quoteNoRef} added`)
          if (!this._suppressSaveToast) this.$notification.success('', `New quote ${this.quoteNoRef} added`)
        }

        this.setInitialQuoteCustomer()

        this.$eventHub.$emit(EventHubTypes.EntitySaved)
        this.$eventHub.$emit(EventHubTypes.ImageCountChanged, this.entity.imageIds.length)

        const attachments = await QuoteService.getQuoteAttachments(this.entity.quoteId)
        let count = Object.values(attachments.data).reduce((total, row) => total + Object.values(row.quoteAttachments).length, 0)
        this.$eventHub.$emit(EventHubTypes.DocumentCountChanged, count)

        if(!!routeToPriceParts){
          this.$router.push({
            name: QuoteRoutes.QuotePriceParts.name
          })
        }

        this.resetAutoSaveFailures()
        if (this.setAutoSaveState) this.setAutoSaveState({ isFailed: false, isEditing: false, isSaving: false })

        return true
      } catch (e) {
        this.$hideSpinner()
        console.log(e)
        if (e.response && e.response.request && e.response.request.status === HttpStatus.CONFLICT) {
          this.isSaveConflictModalActive = true
        } else if (e.response) {
          this.$notification.openMessageXhrError(title, e)
        } else {
          this.$notification.openNotificationWithType('danger', title, e.message)
        }
        return false
      } finally {
        this.customerSaveAction = ''
        this.isSaving = false
        this.$hideSpinner()
      }
    },
    // After copying into an existing quote with autosave on, persist the copy and fully reload so
    // all server-synced state (real item ids, copied images, quote assessments) is correctly set.
    // Reuses the standard save() path (which reloads via getEntity(true)); the generic "saved"
    // toast is suppressed because the copy-success toast was already shown.
    async saveCopiedQuoteWithAutosave() {
      try {
        this._suppressSaveToast = true
        await this.save(false, false, false, false)
      } catch (e) {
        console.error('Failed to persist copied quote', e)
      } finally {
        this._suppressSaveToast = false
      }
    },
    purgeNewEmptyLineItems() {
      // Remove (NEW) empty line items before saving to avoid validation errors, lines that don't have itemDesc or value and were just added.
      // Also remove never-synced deleted items (isNew && deleted): the server has no row for
      // them, and the full PUT would otherwise INSERT them as live items (UpdateQuoteItems adds
      // every IsNew item and never sets the Deleted column). Mirrors the items autosave, which
      // drops them from its payload and the live arrays.
      const keep = (i) => !(i.isNew && i.deleted) && (!i.isNew || (i.isNew && (i.itemDesc !== '' || i.value !== 0)))
      this.entity.labours = this.entity.labours.filter(keep)
      this.entity.parts = this.entity.parts.filter(keep)
      this.entity.others = this.entity.others.filter(keep)
      this.entity.miscs = this.entity.miscs.filter(keep)
      this.entity.sublets = this.entity.sublets.filter(keep)
    },
    async triggerIsNewOwnerPrompt() {
      // const customerDiff = DeepDiff.diff(this.quoteCustomer, this.initialQuoteCustomer)
      // const isPerson = this.currentCustomerSnapshot.isPerson

      const prompt = this.isNewCustomerPrompt && !this.customerSaveAction
      if (prompt) {
        this.customerModalSelection = 'create'

        const affectedQuotes = await QuoteService.getQuotesByVehicle(this.entity.quoteId, this.vehicle.id, this.vehicle.customer.key)
        this.affectedQuotesCount = affectedQuotes.length

        return true
      } else {
        this.affectedQuotesCount = 0
      }
      return false
      // if (customerDiff && !this.customerSaveAction) {
      //   const paths = customerDiff.map((d) => d.path).flat()
      //   let prompt = paths.includes('firstname') || paths.includes('lastname') || paths.includes('phones')
      //   if (!isPerson) {
      //     prompt = paths.includes('companyName')
      //   }
      //   if (prompt) {
      //     this.isCustomerCreateModifyModalActive = true
      //     return true
      //   }
      //   return false
      // }
    },
    async handleCustomerModalSave() {
      if (this.customerModalSelection === 'create') {
        await this.createVehicleCustomer()
      } else {
        await this.modifyCustomer()
      }
      if (this.toRoute) {
        const dest = this.toRoute
        this.toRoute = null
        await this.$nextTick()
        this.$router.push({ name: dest.name, params: dest.params, query: dest.query }).catch(() => {})
      }
    },
    async handleCustomerModalCancel() {
      this.isCustomerCreateModifyModalActive = false
      await this.getEntity(true)
      // getQuoteAssests() inside getEntity is not awaited, so call it explicitly here
      // to ensure this.customer/vehicle/insurer are set before EntitySaved fires and
      // QuoteHeader.updateInnerObjects() clones them into the form fields.
      await this.getQuoteAssests()
      if (this.setAutoSaveState) {
        this.setAutoSaveState({ isEditing: false, isSaving: false, isFailed: false })
      }
      this.$eventHub.$emit(EventHubTypes.EntitySaved)
      if (this.toRoute) {
        const dest = this.toRoute
        this.toRoute = null
        await this.$nextTick()
        this.$router.push({ name: dest.name, params: dest.params, query: dest.query }).catch(() => {})
      }
    },
    setCustomerState(isNew) {
      if (!this.customer) return

      this.customer.isNew = isNew

      // Helper function to safely update arrays
      const updateItems = (items) => {
        if (Array.isArray(items)) {
          items.forEach(item => {
            if (item) {
              item.isNew = isNew
              item.id = this.$guid.newGuid()
            }
          })
        }
      }

      // Update addresses
      updateItems(this.customer.addresses)

      // Update contacts and their nested items
      if (Array.isArray(this.customer.contacts)) {
        this.customer.contacts.forEach(obj => {
          if (obj) {
            obj.isNew = isNew
            obj.id = this.$guid.newGuid()
            if(obj.contact){
              obj.contact.isNew = isNew
              obj.contact.id = this.$guid.newGuid()
                updateItems(obj.contact.addresses)
                updateItems(obj.contact.emails)
                updateItems(obj.contact.phones)
            }
          }
        })
      }

      // Update emails
      updateItems(this.customer.emails)

      // Update phones
      updateItems(this.customer.phones)
    },
    async createVehicleCustomer() {
      this.isCustomerCreateModifyModalActive = false
      this.customerSaveAction = 'create'
      this.customer.id = this.$guid.newGuid()
      this.setCustomerState(true)
      this.vehicle.customer.key = this.customer.id
      this.vehicle.customer.value = this.customer.fullname
      this.vehicle.isNew = true
      this.vehicle.id = this.$guid.newGuid()
      this.entity.customerId = this.customer.id
      this.entity.vehicleId = this.vehicle.id
      console.log('createVehicleCustomer', this.customer)
      await this.save()
    },
    async modifyCustomer() {
      this.isCustomerCreateModifyModalActive = false
      this.customerSaveAction = 'modify'
      await this.save()
    },
    delete() {
      this.entity.deleted = true
    },
    cancel() {
      this.saveSnapshot(_cloneDeep(this.entity))
      // Skip unsaved modal if autosave is active for this quote (new quotes are never autosaved)
      if (!this.autoSaveActiveForQuote && this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue && !this.readOnlyView) {
        // console.log(this.snapshotDiff)
        this.isUnsavedModalActive = true
      } else {
        if (this.toRoute) {
          this.$router.push(this.toRoute.fullPath)
        } else if (this.returnRoute && !_isEmpty(this.returnRoute)) {
          this.$router.push(this.returnRoute.fullPath)
        } else if (this.returnUrl) {
          window.location.href = `${process.env.VUE_APP_ROOT_URI}${this.returnUrl}`
        } else {
          this.$router.push({
            name: QuoteRoutes.QuoteListView.name
          })
        }
      }
    },
    printExcessInvoice() {
      const params = {
        QuoteID: this.entity.quoteId,
        InvoiceNo: this.excessInvoice.invoiceNo,
        InvoiceDate: this.formatDateLocale(this.excessInvoice.invoiceDate, this.$userInfo.locale),
        InsurerID: this.entity.insurerId,
        CustomerID: this.excessInvoice.assetId, //this.entity.customerId,
        CompanyID: this.entity.companyId,
        ExcessAmount: `${this.excessInvoice.excessAmount}`,
        OwnerContributionAmt: `${this.excessInvoice.ownerContribution}`,
        ExtraCharge: `${this.excessInvoice.extraCharge}`,
        InvoiceID: this.excessInvoice.invoiceId
      }
      // const query = this.$lzstring.compressToEncodedURIComponent(
      //   Object.keys(params)
      //     .map(e => `${e}=${params[e]}`)
      //     .join('&')
      // )
      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      const parameterId = this.$guid.newGuid()
      StoreUtil.setLocalStorage(parameterId, 'parameters', keyValuePairs)

      const emailer = new Emailer()
      emailer.assetId = this.entity.quoteId
      emailer.assetType = EmailAssetTypes.Quote
      emailer.remark = `Excess Invoice ${this.excessInvoice.prefix}${this.excessInvoice.invoiceNo}${this.excessInvoice.suffix}`
      emailer.assetTypes = [AssetTypes.Customer, AssetTypes.Insurer]
      emailer.remarkTypeId = RemarkTypes.OtherSystemRemark
      emailer.subject = `Excess Invoice ${this.excessInvoice.prefix}${this.excessInvoice.invoiceNo}${this.excessInvoice.suffix} - Quote No: ${
        this.entity.quoteNo || 'NA'
      } - Claim No: ${this.entity.claimNo || 'NA'} - Rego: ${this.entity.vehicleRego || 'NA'}`

      // emailer.subject = `Excess Invoice ${this.excessInvoice.prefix}${this.excessInvoice.invoiceNo}${this.excessInvoice.suffix}`
      emailer.reportName = `Excess-Invoice_${this.excessInvoice.prefix}${this.excessInvoice.invoiceNo}${this.excessInvoice.suffix}`
      StoreUtil.setLocalStorage(emailer.id, 'emailer', emailer)
      const routeData = this.$router.resolve({
        name: PrintPreviewRoutes.PrintPreview.name,
        params: { reportName: this.entity.excessWithGst ? 'rptExcessInvoiceWithGST' : 'rptExcessInvoice' },
        query: { parameterId: parameterId, emailerId: emailer.id, isNewTab: true }
      })
      window.open(routeData.href, '_blank')
    },
    printOcInvoice() {
      const params = {
        QuoteID: this.entity.quoteId,
        InvoiceNo: this.ocInvoice.invoiceNo,
        InvoiceDate: this.formatDateLocale(this.ocInvoice.invoiceDate, this.$userInfo.locale),
        InsurerID: this.entity.insurerId,
        CustomerID: this.entity.customerId,
        CompanyID: this.entity.companyId,
        OwnerContributionAmt: `${this.ocInvoice.ownerContribution}`,
        ExtraCharge: `${this.ocInvoice.extraCharge}`,
        InvoiceID: this.ocInvoice.invoiceId
      }
      // const query = this.$lzstring.compressToEncodedURIComponent(
      //   Object.keys(params)
      //     .map(e => `${e}=${params[e]}`)
      //     .join('&')
      // )
      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      const parameterId = this.$guid.newGuid()
      StoreUtil.setLocalStorage(parameterId, 'parameters', keyValuePairs)

      const emailer = new Emailer()
      emailer.assetId = this.entity.quoteId
      emailer.assetType = EmailAssetTypes.Quote
      emailer.assetTypes = [AssetTypes.Customer, AssetTypes.Insurer]
      emailer.remark = `Owner Contribution Invoice ${this.ocInvoice.prefix}${this.ocInvoice.invoiceNo}${this.ocInvoice.suffix}`
      emailer.remarkTypeId = RemarkTypes.OtherSystemRemark
      emailer.subject = `Owner Contribution Invoice ${this.ocInvoice.prefix}${this.ocInvoice.invoiceNo}${this.ocInvoice.suffix}`
      emailer.reportName = `Owner-Contribution-Invoice_${this.ocInvoice.prefix}${this.ocInvoice.invoiceNo}${this.ocInvoice.suffix}`
      StoreUtil.setLocalStorage(emailer.id, 'emailer', emailer)
      const routeData = this.$router.resolve({
        name: PrintPreviewRoutes.PrintPreview.name,
        params: { reportName: 'rptExcessInvoiceOwnerContribution' },
        query: { parameterId: parameterId, emailerId: emailer.id, isNewTab: true }
      })
      window.open(routeData.href, '_blank')
    },
    printMyInvoice() {
      let reportName = 'rptInvoiceMy'
      const params = {
        QuoteID: this.entity.quoteId,
        InvoiceNo: this.invoice ? `${this.invoice.prefix}${this.invoice.invoiceNo}${this.invoice.suffix}/${this.invoice.invoiceType}` : '',
        InvoiceDate: this.formatDateLocale(this.invoice.invoiceDate, this.$userInfo.locale),
        InsurerID: this.entity.insurerId,
        CustomerID: this.entity.customerId,
        CompanyID: this.entity.companyId,
        InvoiceID: this.invoice.invoiceId,
        timezoneoffset: this.$filters.getSiteTimezoneOffset()
      }

      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      const parameterId = this.$guid.newGuid()
      StoreUtil.setLocalStorage(parameterId, 'parameters', keyValuePairs)

      const emailer = new Emailer()
      emailer.assetId = this.entity.quoteId
      emailer.assetType = EmailAssetTypes.Quote
      emailer.assetTypes = [AssetTypes.Customer, AssetTypes.Insurer]
      emailer.remark = `Invoice ${this.invoice.prefix}${this.invoice.invoiceNo}${this.invoice.suffix}`
      emailer.remarkTypeId = RemarkTypes.OtherSystemRemark
      emailer.subject = `Invoice ${this.invoice.prefix}${this.invoice.invoiceNo}${this.invoice.suffix} - Quote No: ${this.entity.quoteNo || 'NA'} - Claim No: ${
        this.entity.claimNo || 'NA'
      } - Rego: ${this.entity.vehicleRego || 'NA'}`
      // emailer.subject = `Invoice ${this.invoice.prefix}${this.invoice.invoiceNo}${this.invoice.suffix}`
      emailer.reportName = `Invoice_${this.invoice.prefix}${this.invoice.invoiceNo}${this.invoice.suffix}`
      StoreUtil.setLocalStorage(emailer.id, 'emailer', emailer)
      const routeData = this.$router.resolve({
        name: PrintPreviewRoutes.PrintPreview.name,
        params: { reportName: reportName },
        query: { parameterId: parameterId, emailerId: emailer.id, isNewTab: true }
      })
      window.open(routeData.href, '_blank')
    },
    formatDateLocale(value, locale, format = '2-digit') {
      const date = new Date(Date.parse(`${value}`))
      const options = { year: 'numeric', month: format, day: '2-digit' }
      if (Intl) {
        return Intl.DateTimeFormat(locale, options).format(date)
      } else {
        return date.toLocaleDateString(locale, options)
      }
    },
    skipSave() {
      this.isUnsavedModalActive = false
      this.isSkipSave = true
      this.cancel()
    },
    async saveContinue() {
      this.isUnsavedModalActive = false
      this.isSaveContinue = true
      this.isSaveContinue = await this.save()
      if (this.isSaveContinue) {
        this.cancel()
      }
    },
    closeModal() {
      this.isUnsavedModalActive = false
      this.isSaveConflictModalActive = false
      this.isSaveContinue = false
      this.isPrintOptionsActive = false
    },
    persistQueries() {
      if (this.returnUrl) {
        sessionStorage.setItem(`${this.$userInfo.sessionId}|quote|returnUrl`, this.returnUrl)
      }
      if (this.invoiceType) {
        sessionStorage.setItem(`${this.$userInfo.sessionId}|quote|invoiceType`, this.invoiceType)
      }
    },
    removeQueries() {
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|quote|returnUrl`)
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|quote|invoiceType`)
    },
    replaceRoute(id) {
      const newMeta = Object.assign(this.$route.meta, {
        returnUrl: this.returnUrl,
        invoiceType: this.invoiceType
      })
      this.$router.replace({
        name:
          this.invoiceType === InvoiceTypes.Quote || this.invoiceType === InvoiceTypes.Gst
            ? QuoteRoutes.QuoteInvoice.name
            : QuoteRoutes.QuoteExcessInvoice.name,
        params: { quoteId: id },
        meta: newMeta
      })
    },
    clearSessionStorage() {
      this.removeQueries()
    },
    async newAdditional() {
      const canStartAdditional = !this.entity.orm
        ? true
        : this.entity.invoices.some(
            (i) =>
              i.invoiceType === InvoiceTypes.Quote &&
              !i.deleted &&
              (this.entity.orm.quoteStatusId === OrmQuoteStatusTypes.QuoteInvoiceSubmitted || OrmQuoteStatusTypes.PaymentAuthorised)
          )
      if (canStartAdditional) {
        this.setReturnRoute(this.$route)
        this.addStoreSupplementaryItem(this.entity.quoteNo)
      } else {
        this.$notification.openNotificationWithType(
          'danger',
          'Repairer Quote',
          //eslint-disable-next-line
          "Variation for ORM quote should be done on main quote if it's not already invoiced",
          6000
        )
      }
    },
    exportQuote() {
      this.isQuoteExportModalActive = true
    },
    async closeQuoteExportModal() {
      this.isQuoteExportModalActive = false
      await this.getEntity(true)
      this.$eventHub.$emit(EventHubTypes.EntityReloaded)
    },
    async showCopyQuoteModal() {
      this.imageIds = await QuoteService.getImageIds(this.entity.quoteId)
      this.isCopyQuoteModalActive = true
    },
    copyQuote(destinationId, isCopyImages, isOverwrite) {
      // console.log('copy', destinationId, isCopyImages)
      this.isCopyQuoteModalActive = false
      this.copyStoreQuote({ sourceId: this.entity.quoteId, destinationId: destinationId, isCopyImages: isCopyImages, isOverwrite: isOverwrite })
    },
    sendSms() {
      var jobStart = new Date(this.entity.jobStart).toLocaleDateString(this.$userInfo.locale)
      var mobile = ''

      mobile = this.quoteCustomer.phones.find((a) => a.type === PhoneTypes.Mobile.toString())

      if (mobile == undefined) {
        mobile = ''
      } else {
        mobile = mobile.no
      }

      this.smsDetails = new SmsSendMessageModel(this.entity.quoteId, this.quoteCustomer.fullname, this.quoteVehicle.rego, jobStart, this.entity.excess, mobile)
      this.isSmsModalActive = true
    },
    closeSmsModal() {
      this.isSmsModalActive = false
    },
    changeQuote(subQuote) {
      // console.log(subQuote.key)
      this.$router.push({
        name: this.$route.name,
        params: { quoteId: subQuote.value }
      })
    },
    async deleteEntity(confirmDelete) {
      this.isConfirmModalActive = false
      if (confirmDelete) {

        const isSuppQuote = this.entity.subQuoteNo > 0

        if (this.entity.subQuoteNo === 0 && this.entity.subQuoteNos.length > 1) {
          // Delete all supplementary quotes
          const vm = this
          const quoteIds = this.entity.subQuoteNos.filter((q) => q.key !== vm.entity.subQuoteNo).map((q) => q.value)
          QuoteService.deleteMultipleEntities(quoteIds)
        }
        this.entity.deleted = true
        await this.save(true)

        if (isSuppQuote) {
          this.$router.push({
            name: QuoteRoutes.QuoteHeader.name,
            params: { quoteId: this.entityMainQuote.quoteId }
          })
        }
      }
    },
    async getAudanetPnetSetting() {
      this.audanetSetting = await QuoteService.getExternalSetting('audatex')
      this.pnetSetting = await QuoteService.getExternalSetting('pnet')
    },
    deleteItem(item, items) {
      if (item.isNew) {
        const itemIndex = items
          .map(function (obj) {
            return obj.quoteItemId
          })
          .indexOf(item.quoteItemId)
        if (itemIndex >= 0) {
          items.splice(itemIndex, 1)
        }
      } else {
        item.deleted = true
        item.isDeleted = true
        item.itemStatus = QuoteItemStatusTypes.Deleted
      }
    },
    onOpgCodeChanged() {
      if (!this.entity.readOnly && this.isRacq) {
        // RACQ Consumables percentage
        this.addUpdateRacqConsumable()
        this.scheduleItemsSave()
      } else if (!this.entity.readOnly && this.isNtar) {
        // console.log('opgTotal isNtar')
        this.addUpdatePaintConsumable()
        this.addUpdatePaintMaterial()
        this.addUpdateM3PlusAllowances()
        this.addUpdateSetupColourMatch1()
        this.addUpdateOpgPaintMaterials()
        this.addUpdateSetupColourMatch2()
        this.scheduleItemsSave()
      }
    },
    addUpdateRacqConsumable() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        const total = this.labourTotal + this.opgTotal
        const racqConsumable = this.quoteInsurer.insurerConsumables.find((c) => c.typeID === 4)
        const percentage = racqConsumable.value
        const consumableAmount = roundAwayFromZero((total * percentage) / 100)
        // console.log('RACQ Consumable =', consumableAmount)
        let miscItem = this.entity.miscs.find((i) => i.itemNo === racqConsumable.itemNo && !i.deleted && !i.deleteOtherItem)
        if (consumableAmount > 0) {
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, racqConsumable.itemNo, 'Total Consumables', ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = consumableAmount
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('RACQ consumable item added', 'success', 'bottom')
          } else {
            miscItem.value = consumableAmount
            // this.showToast('RACQ consumable item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('RACQ consumable item delete', 'danger', 'bottom')
        }
      })
    },
    addUpdateWeldAllowance() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        let weldAllowance = this.quoteInsurer.insurerConsumables.find((c) => c.typeID === 5)
        if (this.isNtar) {
          const standardItem = this.standardLabourItems.find((i) => i.itemNo === weldAllowance.itemNo)
          weldAllowance.description = standardItem.itemDesc
        }
        let miscItem = this.entity.miscs.find((i) => i.itemNo === weldAllowance.itemNo && !i.deleted && !i.deleteOtherItem)
        const weldAllowanceAmount = roundAwayFromZero(this.weldHourTotal * weldAllowance.value)
        if (weldAllowanceAmount > 0) {
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, weldAllowance.itemNo, weldAllowance.description, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = weldAllowanceAmount
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('eMTA Weld Allowance item added', 'success', 'bottom')
          } else {
            miscItem.value = weldAllowanceAmount
            // this.showToast('eMTA Weld Allowance item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('eMTA Weld Allowance item deleted', 'danger', 'bottom')
        }
      })
    },
    addUpdateRepairPanelConsumable() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        // NTAR Panel Consumable. Per repair hour. ItemNo 9991
        const rtrmVersion = this.entity.verRtrm
          ? this.entity.verRtrm
          : Math.max.apply(
              Math,
              this.quoteInsurer.insurerConsumables.map(function (c) {
                return c.versionNo
              })
            )
        const repairConsumable = this.quoteInsurer.insurerConsumables.find((c) => c.typeID === 1 && c.versionNo === rtrmVersion)
        const hours = this.entity.labours
          .filter((i) => !i.deleted && !i.reportOnly && (i.itemType === ItemCategoryTypes.REP || i.itemType === ItemCategoryTypes.RWA))
          .reduce(function (total, item) {
            return total + item.hourValue
          }, 0)
        const consumableAmount = roundAwayFromZero(hours * repairConsumable.value)
        let miscItem = this.entity.miscs.find((i) => i.itemNo === repairConsumable.itemNo && !i.deleted && !i.deleteOtherItem)

        console.log('Update Repair Consumable -> ', 'Version : ', rtrmVersion, 'Consumable Amount: ', consumableAmount)

        if (consumableAmount > 0) {
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, repairConsumable.itemNo, repairConsumable.description, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = consumableAmount
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('Panel Consumables item added', 'success', 'bottom')
          } else {
            miscItem.value = consumableAmount
            // this.showToast('Panel Consumables item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('Panel Consumables item deleted', 'danger', 'bottom')
        }
      })
    },
    addUpdatePaintConsumable() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        // NTAR Paint Consumable. Per paing hour. ItemNo 9992
        const rtrmVersion = this.entity.verRtrm
          ? this.entity.verRtrm
          : Math.max.apply(
              Math,
              this.quoteInsurer.insurerConsumables.map(function (c) {
                return c.versionNo
              })
            )
        const paintConsumable = this.quoteInsurer.insurerConsumables.find((c) => c.typeID === 3 && c.versionNo === rtrmVersion)
        const hours = this.entity.labours
          // eslint-disable-next-line no-unexpected-multiline
          .filter(
            (i) =>
              !i.deleted &&
              !i.reportOnly &&
              (i.itemType === ItemCategoryTypes.PAINT || i.itemType === ItemCategoryTypes.OPG) &&
              i.opgCode === this.vehicle.paintGroup
          )
          .reduce(function (total, item) {
            return total + item.hourValue
          }, 0)
        const amount = roundAwayFromZero(hours * paintConsumable.value)
        let miscItem = this.entity.miscs.find((i) => i.itemNo === paintConsumable.itemNo && !i.deleted && !i.deleteOtherItem)

        console.log('Update Paint Consumable -> ', 'Version : ', rtrmVersion, 'Consumable Amount: ', amount)

        if (amount > 0) {
          const presentAsItem = new QuoteItemPresentAsModel('PAINM', '', Math.max(100, 0))
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, paintConsumable.itemNo, paintConsumable.description, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = amount
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('Paint Consumables item added', 'success', 'bottom')
            miscItem.presentAs.push(presentAsItem)
          } else {
            miscItem.value = amount
            // this.showToast('Paint Consumables item updated', 'success', 'bottom')
            if (miscItem.presentAs === null) {
              miscItem.presentAs = []
              miscItem.presentAs.push(presentAsItem)
            }
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('Paint Consumables item deleted', 'danger', 'bottom')
        }
      })
    },
    addUpdatePaintMaterial() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        // NTAR Paint Materia. Per paint hour
        const rtrmVersion = this.entity.verRtrm
          ? this.entity.verRtrm
          : Math.max.apply(
              Math,
              this.quoteInsurer.insurerConsumables.map(function (c) {
                return c.versionNo
              })
            )

        // Use the live edited vehicle (this.vehicle), NOT the store baseline (this.quoteVehicle).
        // quoteVehicle only refreshes on reload, so after a header paint-group change (e.g. S2->M2)
        // it stays stale and this lookup would resolve the OLD group's material item (SO-1901).
        const paintMaterial = this.quoteInsurer.insurerPaintMaterials.find((c) => c.type === this.vehicle.paintGroup && c.versionNo === rtrmVersion)
        const hours = this.entity.labours
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly && i.itemType === ItemCategoryTypes.PAINT && i.opgCode === this.vehicle.paintGroup)
          .reduce(function (total, item) {
            return total + item.hourValue
          }, 0)
        const amount = roundAwayFromZero(hours * paintMaterial.value)
        console.log('addUpdatePaintMaterial', hours, amount)
        let miscItem = this.entity.miscs.find((i) => i.itemNo === paintMaterial.itemNo && !i.deleted && !i.deleteOtherItem)

        console.log('Update Paint Material -> ', 'Version : ', rtrmVersion, 'Consumable Amount: ', amount)

        if (amount > 0) {
          const presentAsItem = new QuoteItemPresentAsModel('PAINM', '', Math.max(100, 0))
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, paintMaterial.itemNo, `PAINT MATERIALS ${paintMaterial.type}`, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = amount
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('Paint Material item added', 'success', 'bottom')
            miscItem.presentAs.push(presentAsItem)
          } else {
            miscItem.value = amount
            if (miscItem.presentAs === null) {
              miscItem.presentAs = []
              miscItem.presentAs.push(presentAsItem)
            }
            // this.showToast('Paint Material item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('Paint Material item deleted', 'danger', 'bottom')
        }
      })
    },
    addUpdateM3PlusAllowances() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        // this.vehicle is the live edited value; this.quoteVehicle is a stale baseline (see SO-1901).
        if (this.vehicle.paintGroup === PaintGroupTypes.M3 && this.vehicle.paintGroupPlus && this.isNtar) {
          const rtrmVersion = this.entity.verRtrm
            ? this.entity.verRtrm
            : Math.max.apply(
                Math,
                this.quoteInsurer.insurerConsumables.map(function (c) {
                  return c.versionNo
                })
              )

          const m3plus = this.quoteInsurer.insurerPaintMaterials.find((c) => c.type === 'M3Plus' && c.versionNo === rtrmVersion)

          // M3+ Allowances. Per paint hour
          const allowanceRate = m3plus ? m3plus.value : 0.32
          const itemNo = m3plus ? m3plus.itemNo : '9970'

          const paintHours = this.entity.labours
            // eslint-disable-next-line no-unexpected-multiline
            .filter((i) => !i.deleted && !i.reportOnly && i.itemType === ItemCategoryTypes.PAINT && i.opgCode === this.vehicle.paintGroup)
            .reduce(function (total, item) {
              return total + item.hourValue
            }, 0)
          const paintRate = this.entity.rates[0]
          const allowanceHours = allowanceRate * paintHours
          const allowance = roundAwayFromZero(allowanceHours * paintRate.rate)

          let miscItem = this.entity.miscs?.find((i) => i.itemNo === itemNo && !i.deleted && !i.deleteOtherItem)
          console.log(this.$options.name, paintRate, paintHours, allowance, allowanceRate)

          console.log('Update M3Plus Material -> ', 'Version : ', rtrmVersion, 'Consumable Amount: ', allowance, 'misc item', miscItem)

          if (!miscItem && allowance > 0) {
            miscItem = new QuoteItemModel(this.entity.quoteId, itemNo, 'M3+ Allowances', ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = allowance
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.$nextTick(() => {
              this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            })
          } else if (allowance > 0) {
            miscItem.value = allowance
          } else if (miscItem && allowance === 0) {
            this.deleteItem(miscItem, this.entity.miscs)
          }
        }
      })
    },
    addUpdateSetupColourMatch1() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        const standardItem = this.standardLabourItems.find((i) => i.itemNo === '9998')
        const hours = this.entity.labours
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly && i.itemType === ItemCategoryTypes.PAINT && i.opgCode === this.vehicle.paintGroup)
          .reduce(function (total, item) {
            return total + item.hourValue
          }, 0)
        let miscItem = this.entity.miscs.find((i) => i.itemNo === standardItem.itemNo && !i.deleted && !i.deleteOtherItem)

        const isOtherPaintGroup = this.entity.labours.some(
          (i) => !i.deleted && !i.reportOnly && i.itemType === ItemCategoryTypes.PAINT && i.opgCode !== this.vehicle.paintGroup
        )

        // only show setup colour match 1 if there are paint hours and no other paint group
        if (hours > 0 && !isOtherPaintGroup) {
          const setupHour = this.quoteInsurer.insurerSpecialRates.find((i) => i.itemNo === '9998')
          const value = setupHour ? setupHour.value : standardItem.rrHour
          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, standardItem.itemNo, standardItem.itemDesc, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = roundAwayFromZero(value * this.entity.shopRate)
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('Setup Colour Match 1 item added', 'success', 'bottom')
          } else {
            miscItem.value = roundAwayFromZero(value * this.entity.shopRate)
            // this.showToast('Setup Colour Match 1 item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast('Setup Colour Match 1 item deleted', 'danger', 'bottom')
        }
      })
    },
    addUpdateOpgPaintMaterials() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        const paintMaterials = this.quoteInsurer.insurerPaintMaterials
        for (var i = 0; i < paintMaterials.length; i++) {
          const paintMaterial = paintMaterials[i]
          // console.log(paintMaterial.itemNo)
          const paintLayer = paintMaterial.type
          const amount = this.entity.labours
            // eslint-disable-next-line no-unexpected-multiline
            .filter((i) => !i.deleted && !i.reportOnly && i.opgCode === paintLayer && i.opgCode !== this.vehicle.paintGroup)
            .reduce(function (total, item) {
              return total + item.hourValue * paintMaterial.value
            }, 0)

          let miscItem = this.entity.miscs.find((i) => i.itemNo === paintMaterial.itemNo && !i.deleted && !i.deleteOtherItem)
          if (amount > 0) {
            if (!miscItem) {
              miscItem = new QuoteItemModel(this.quoteId, paintMaterial.itemNo, `PAINT MATERIALS ${paintMaterial.type}`, ItemCategoryTypes.MISC)
              miscItem.lineNumber = this.nextLineNumber
              miscItem.value = amount
              miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
              this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            } else {
              if (paintMaterial.type === this.vehicle.paintGroup) {
                miscItem.value += amount
              } else {
                miscItem.value = amount
              }
            }
            // Compare against the live edited group (this.vehicle), NOT the stale store baseline
            // (this.quoteVehicle). Otherwise, after a paint-group change, the old group's material
            // line is never removed and duplicates alongside the new group's (SO-1901).
          } else if (miscItem && paintMaterial.type !== this.vehicle.paintGroup && !this.vehicle.paintGroupPlus) {
            this.deleteItem(miscItem, this.entity.miscs)
          }
        }
      })
    },
    addUpdateSetupColourMatch2() {
      const derivedGuard = this.getDerivedItemGuard()
      derivedGuard.run(() => {
        const standardItem = this.standardLabourItems.find((i) => i.itemNo === '9999')
        let miscItem = this.entity.miscs.find((i) => i.itemNo === standardItem.itemNo && !i.deleted && !i.deleteOtherItem)
        const hours = this.entity.labours
          // eslint-disable-next-line no-unexpected-multiline
          .filter((i) => !i.deleted && !i.reportOnly && i.opgCode !== this.vehicle.paintGroup)
          .reduce(function (total, item) {
            return total + item.hourValue
          }, 0)

        if (this.entity.labours.length > 0 && hours > 0) {
          const setupHour = this.quoteInsurer.insurerSpecialRates.find((i) => i.itemNo === '9999')
          const value = setupHour ? setupHour.value : standardItem.rrHour

          if (!miscItem) {
            miscItem = new QuoteItemModel(this.quoteId, standardItem.itemNo, standardItem.itemDesc, ItemCategoryTypes.MISC)
            miscItem.lineNumber = this.nextLineNumber
            miscItem.value = roundAwayFromZero(value * this.entity.shopRate)
            miscItem.sortNo = this.entity.miscs.length ? Math.max(...this.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            this.entity.miscs.splice(this.entity.miscs.length, 1, miscItem)
            // this.showToast('Setup Colour Match 2 item added', 'success', 'bottom')
          } else {
            miscItem.value = roundAwayFromZero(value * this.entity.shopRate)
            // this.showToast('Setup Colour Match 2 item updated', 'success', 'bottom')
          }
        } else if (miscItem) {
          this.deleteItem(miscItem, this.entity.miscs)
          // this.showToast(`Setup Colour Match 2 item deleted`, 'danger', 'bottom')
        }
      })
    },
    // async setupFabButtons() {
    //   this.fabActions.splice(this.fabActions.length, 1, {
    //     name: 'copyQuote',
    //     icon: 'content-copy',
    //     color: '#a8a145',
    //     tooltip: 'Copy Quote'
    //   })
    //   // this.fabActions.splice(this.fabActions.length, 1, {
    //   //   name: 'newAdditional',
    //   //   icon: 'plus-outline',
    //   //   color: '#c14747',
    //   //   tooltip: 'New Additional'
    //   // })
    //   this.fabActions.splice(this.fabActions.length, 1, {
    //     name: 'exportQuote',
    //     icon: 'export',
    //     color: '#2c5ba5',
    //     tooltip: 'Export'
    //   })
    // },
    showItemsValidationErrors() {
      if (this.$v.entity.labours.$invalid) {
        this.$v.entity.labours.$touch()
      }
      if (this.$v.entity.others.$invalid) {
        this.$v.entity.others.$touch()
      }
      if (this.$v.entity.parts.$invalid) {
        this.$v.entity.parts.$touch()
      }
      if (this.$v.entity.opgs.$invalid) {
        this.$v.entity.opgs.$touch()
      }
      if (this.$v.entity.miscs.$invalid) {
        this.$v.entity.miscs.$touch()
      }
      if (this.$v.entity.sublets.$invalid) {
        this.$v.entity.sublets.$touch()
      }
      if (this.$v.detailGroup.$invalid) {
        this.$v.detailGroup.$touch()
      }
      if (this.$v.vehicleCustomerGroup.$invalid) {
        this.$v.vehicleCustomerGroup.$touch()
      }
      if (this.$v.estimateJobStartEnd.$invalid) {
        this.$v.estimateJobStartEnd.$touch()
      }
    },
    labelize(name) {
      return name
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, s => s.toUpperCase())
    },
    // logValidationErrors() {
    //   const errors = []

    //   // Helper function to get validation error types for a field
    //   const getValidationErrors = (field) => {
    //     if (!field || !field.$params) return []
    //     return Object.keys(field.$params).filter(key => field[key] === false)
    //   }

    //   // Entity fields validation - loop through all entity validation fields
    //   if (this.$v.entity) {
    //     Object.keys(this.$v.entity).forEach(key => {
    //       // Skip special Vuelidate properties and item arrays
    //       if (key.startsWith('$') || ['labours', 'parts', 'opgs', 'others', 'miscs', 'sublets', 'invoices'].includes(key)) {
    //         return
    //       }

    //       const field = this.$v.entity[key]
    //       if (field && field.$invalid) {
    //         const errorTypes = getValidationErrors(field)
    //         if (errorTypes.length > 0) {
    //           errors.push(`${this.labelize(key)}: ${errorTypes.join(', ')}`)
    //         }
    //       }
    //     })
    //   }

    //   // Vehicle fields validation - loop through all vehicle validation fields
    //   if (this.$v.vehicle) {
    //     Object.keys(this.$v.vehicle).forEach(key => {
    //       // Skip special Vuelidate properties
    //       if (key.startsWith('$')) return

    //       const field = this.$v.vehicle[key]
    //       if (field && field.$invalid) {
    //         const errorTypes = getValidationErrors(field)
    //         if (errorTypes.length > 0) {
    //           errors.push(`Vehicle ${this.labelize(key)}: ${errorTypes.join(', ')}`)
    //         }
    //       }
    //     })
    //   }

    //   // Customer fields validation - loop through all customer validation fields
    //   if (this.$v.customer) {
    //     Object.keys(this.$v.customer).forEach(key => {
    //       // Skip special Vuelidate properties and nested arrays
    //       if (key.startsWith('$') || ['emails', 'contacts', 'phones', 'addresses'].includes(key)) {
    //         return
    //       }

    //       const field = this.$v.customer[key]
    //       if (field && field.$invalid) {
    //         const errorTypes = getValidationErrors(field)
    //         if (errorTypes.length > 0) {
    //           errors.push(`Customer ${this.labelize(key)}: ${errorTypes.join(', ')}`)
    //         }
    //       }
    //     })

    //     // Customer emails validation
    //     if (this.$v.customer.emails && this.$v.customer.emails.$invalid) {
    //       const emailsIter = this.$v.customer.emails.$each.$iter
    //       Object.keys(emailsIter).forEach(index => {
    //         const emailField = emailsIter[index]
    //         if (emailField.address && emailField.address.$invalid) {
    //           errors.push(`Customer Email #${parseInt(index) + 1}: invalid email address`)
    //         }
    //       })
    //     }

    //     // Customer contacts validation
    //     if (this.$v.customer.contacts && this.$v.customer.contacts.$invalid) {
    //       const contactsIter = this.$v.customer.contacts.$each.$iter
    //       Object.keys(contactsIter).forEach(index => {
    //         const contact = contactsIter[index]
    //         if (contact.contact) {
    //           if (contact.contact.firstName && contact.contact.firstName.$invalid) {
    //             errors.push(`Customer Contact #${parseInt(index) + 1} First Name: required`)
    //           }
    //           if (contact.contact.lastName && contact.contact.lastName.$invalid) {
    //             errors.push(`Customer Contact #${parseInt(index) + 1} Last Name: required`)
    //           }
    //         }
    //       })
    //     }
    //   }

    //   // Insurer fields validation - loop through all insurer validation fields
    //   if (this.$v.insurer) {
    //     Object.keys(this.$v.insurer).forEach(key => {
    //       // Skip special Vuelidate properties
    //       if (key.startsWith('$')) return

    //       const field = this.$v.insurer[key]
    //       if (field && field.$invalid) {
    //         const errorTypes = getValidationErrors(field)
    //         if (errorTypes.length > 0) {
    //           errors.push(`Insurer ${this.labelize(key)}: ${errorTypes.join(', ')}`)
    //         }
    //       }
    //     })
    //   }

    //   // Items validation (labours, parts, etc.)
    //   const itemTypes = [
    //     { key: 'labours', name: 'Labour' },
    //     { key: 'parts', name: 'Part' },
    //     { key: 'opgs', name: 'OPG' },
    //     { key: 'others', name: 'Other Labour' },
    //     { key: 'miscs', name: 'Misc' },
    //     { key: 'sublets', name: 'Sublet' }
    //   ]

    //   itemTypes.forEach(itemType => {
    //     if (this.$v.entity[itemType.key] && this.$v.entity[itemType.key].$invalid) {
    //       const items = this.$v.entity[itemType.key].$each.$iter
    //       Object.keys(items).forEach(index => {
    //         const item = items[index]
    //         if (item.$invalid) {
    //           const itemData = this.entity[itemType.key][index]
    //           if (itemData && !itemData.deleted) {
    //             // Loop through all fields in the item
    //             Object.keys(item).forEach(fieldKey => {
    //               if (fieldKey.startsWith('$')) return

    //               const field = item[fieldKey]
    //               if (field && field.$invalid) {
    //                 const errorTypes = getValidationErrors(field)
    //                 if (errorTypes.length > 0) {
    //                   errors.push(`${itemType.name} Item #${parseInt(index) + 1} ${this.labelize(fieldKey)}: ${errorTypes.join(', ')}`)
    //                 }
    //               }
    //             })
    //           }
    //         }
    //       })
    //     }
    //   })

    //   // Log all errors to console
    //   if (errors.length > 0) {
    //     console.error('=== VALIDATION ERRORS ===')
    //     errors.forEach(error => console.error(`❌ ${error}`))
    //     console.error(`Total: ${errors.length} error(s)`)
    //   }
    // },
    async conflictMerge() {
      this.entity.mergeOnConflict = true
      this.isSaveConflictModalActive = false
      await this.save()
    },
    async conflictReload() {
      this.isSaveConflictModalActive = false
      await this.getEntity(true)
      this.$eventHub.$emit(EventHubTypes.EntitySaved)
      // this.$nextTick(() => {
      //   this.$eventHub.$emit(EventHubTypes.EntitySaved)
      // })
    },
    async selectVehicle(vehicleId, customerId) {
      await Promise.all([this.getQuoteVehicle({ id: vehicleId, refresh: true }), this.getQuoteCustomer({ id: customerId, refresh: true })])
      this.vehicle = _cloneDeep(this.currentVehicleSnapshot)
      if (this.vehicle) this.vehicle.isNew = false
      this.customer = _cloneDeep(this.currentCustomerSnapshot)
      this.setInitialQuoteCustomer()
      this.$nextTick(() => {
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
      })
    },
    async selectCustomer(id) {
      await this.getQuoteCustomer({ id: id, refresh: true })
      this.customer = _cloneDeep(this.currentCustomerSnapshot)
      if(this.entity && this.entity.isNew && this.vehicle.isNew) {
         this.setInitialQuoteCustomer()
      }

      this.entity.customerId = this.customer.id
      this.$nextTick(() => {
        setTimeout(() => {
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
        }, 500)
      })
    },
    async selectInsurer(id) {
      console.log(`Insurer, ${id}, ${this.entity.insurerId}`)
      this.entity.insurerId = id
      await this.getQuoteInsurer({ id: id, refresh: true })
      this.insurer = _cloneDeep(this.currentInsurerSnapshot)
      const isItemsEmpty =
        this.entity.labours.length === 0 &&
        this.entity.parts.length === 0 &&
        this.entity.others.length === 0 &&
        this.entity.opgs.length === 0 &&
        this.entity.miscs.length === 0 &&
        this.entity.sublets.length === 0

      if (isItemsEmpty || this.entity.isNew) {
        this.entity.newMarkup = this.insurer.newMarkup
        this.entity.usedMarkup = this.insurer.usedMarkup
        this.entity.recoreMarkup = this.insurer.recoreMarkup
        this.entity.afterMarketMarkup = this.insurer.afterMarketMarkup
        this.entity.exchangeMarkup = this.insurer.exchangeMarkup
        this.entity.reconditionedMarkup = this.insurer.reconditionedMarkup
        this.entity.parallelMarkup = this.insurer.parallelMarkup
        this.entity.shopRate = this.insurer.shopRate
        this.entity.labourType = this.insurer.labourType
        this.entity.excessWithGst = this.insurer.excessGST
        this.entity.quotingMethod = this.insurer.quotingMethod?? QuotingMethodTypes.Hour
        this.entity.verRtrm = Math.max.apply(
          Math,
          this.insurer.insurerConsumables.map(function (c) {
            return c.versionNo
          })
        )
        // Update quote rates
        this.addInsurerLabourRates(this.insurer)
        // Add or update automatic items to quote
        this.addInsurerAutoItems(this.insurer)
        // Add or update template items to quote
        await this.addInsurerTemplateItems(this.insurer)
      }

      // update excessWthGST for an existing uninvoiced quote with items
      if (!isItemsEmpty && !this.entity.isNew && this.entity.invoices.length === 0) {
        this.entity.excessWithGst = this.insurer.excessGST
      }

      this.$nextTick(() => {
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
      })
      if (this.insurer.estimage) {
        this.entity.isEstimage = true
      } else {
        this.entity.isEstimage = false
      }
    },
    addInsurerLabourRates(insurer) {
      const vm = this
      const isInsurerNtar =
        insurer.labourType === LabourTimeTypes.NTAR || insurer.labourType === LabourTimeTypes.LTAR || insurer.labourType === LabourTimeTypes.eMTA
      insurer.insurerLabourRates.forEach(function (ir) {
        const index = vm.entity.rates.findIndex((qr) => qr.labourCodeId === ir.labourCode)
        if (index > -1) {
          vm.entity.rates[index].rate = isInsurerNtar ? insurer.shopRate : ir.rate
        } else {
          const labourType = vm.$labourTypes.find((t) => t.labourTypeCode === ir.labourType)
          const newRate = {
            rate: isInsurerNtar ? insurer.shopRate : ir.rate,
            quoteVersion: 0,
            quoteId: vm.entity.quoteId,
            labourCodeId: ir.labourCode,
            labourTypeId: labourType.labourTypeId,
            deleted: false,
            createdBy: '',
            createdDate: '',
            modifiedBy: '',
            modifiedDate: '',
            isNew: true,
            isDeleted: false
          }
          vm.entity.rates.splice(vm.entity.rates.length, 1, newRate)
        }
      })
    },
    addInsurerAutoItems(insurer) {
      if (insurer.insurerAutoItems && insurer.insurerAutoItems.length > 0) {
        const vm = this
        let lineNumber = this.nextLineNumber
        insurer.insurerAutoItems.forEach(function (autoItem) {
          let currentItem = vm.entity.miscs.find((i) => i.itemDesc === autoItem.itemDesc && i.itemNo === autoItem.itemNo)
          if (!currentItem) {
            let newItem = new QuoteItemModel(vm.entity.quoteId, autoItem.itemNo, autoItem.itemDesc, ItemCategoryTypes.MISC)
            newItem.value = autoItem.price
            newItem.reportOnly = autoItem.reportOnly
            newItem.sortNo = vm.entity.miscs.length ? Math.max(...vm.entity.miscs.map((i) => i.sortNo)) + 1 : 1
            newItem.lineNumber = lineNumber
            vm.entity.miscs.splice(vm.entity.miscs.length, 1, newItem)
            lineNumber++
            vm.entity.lines++
          } else {
            currentItem.value = autoItem.price
            currentItem.reportOnly = autoItem.reportOnly
          }
        })
      }
    },
    async addInsurerTemplateItems(insurer) {
      if (Guid.validGuid(insurer.templateId)) {
        const templateItems = await QuoteTemplateService.getQuoteTemplateItems(insurer.templateId)
        if (templateItems && templateItems.length > 0) {
          const vm = this

          const vehiclePaintGroup = this.vehicle.paintGroup

          templateItems.forEach(function (templateItem) {
            let currentItem = vm.entity.miscs.find(
              (i) => i.itemDesc === templateItem.itemDesc && i.itemNo === templateItem.itemNo && i.itemType === templateItem.itemType
            )
            if (!currentItem) {
              let newItem = new QuoteItemModel(vm.entity.quoteId, templateItem.itemNo, templateItem.itemDesc, templateItem.itemType)
              if (templateItem.itemType === ItemCategoryTypes.PAINT) {
                newItem.opgCode = !!templateItem.opgCode ? templateItem.opgCode : vehiclePaintGroup
              }
              newItem.value = templateItem.value
              newItem.reportOnly = templateItem.reportOnly
              newItem.sortNo = templateItem.sortNo
              // let sortNo
              switch (templateItem.itemType) {
                case ItemCategoryTypes.RR:
                case ItemCategoryTypes.REP:
                case ItemCategoryTypes.RWA:
                  newItem.rate = vm.getLabourRate(templateItem.itemType)
                  vm.entity.labours.splice(vm.entity.labours.length, 1, newItem)
                  break
                case ItemCategoryTypes.PAINT:
                  newItem.rate = vm.getLabourRate(vm.quoteVehicle.paintGroup)
                  vm.entity.labours.splice(vm.entity.labours.length, 1, newItem)
                  break
                case ItemCategoryTypes.OPG:
                  newItem.rate = vm.getLabourRate(vm.quoteVehicle.paintGroup)
                  vm.entity.opgs.splice(vm.entity.opgs.length, 1, newItem)
                  break
                case ItemCategoryTypes.MECH:
                case ItemCategoryTypes.CD:
                case ItemCategoryTypes.CRUSH:
                case ItemCategoryTypes.FIBER:
                  newItem.rate = vm.getLabourRate(vm.quoteVehicle.paintGroup)
                  vm.entity.others.splice(vm.entity.others.length, 1, newItem)
                  break
                case ItemCategoryTypes.PART:
                  vm.entity.parts.splice(vm.entity.parts.length, 1, newItem)
                  break
                case ItemCategoryTypes.MISC:
                  vm.entity.miscs.splice(vm.entity.miscs.length, 1, newItem)
                  break
                case ItemCategoryTypes.SUBL:
                  vm.entity.sublets.splice(vm.entity.sublets.length, 1, newItem)
                  break
              }
              // newItem.sortNo = templateItem.sortNo // || sortNo
            } else {
              currentItem.value = templateItem.value
              currentItem.itemType = templateItem.itemType
              currentItem.reportOnly = templateItem.reportOnly
              currentItem.sortNo = templateItem.sortNo
            }
          })
        }
      }
    },
    getLabourRate(code) {
      if (!this.entity.rates) {
        return {}
      }
      let rate = this.isNtar ? this.entity.rates[0] : this.entity.rates.find((i) => i.labourCodeId === code)
      return !rate ? 0 : rate.rate
    },
    /**
     *
     * @param useServerMaxLineNumber - defaults to true. If false, anchor new-item numbering to the
     * local synced max instead.
     * @returns {Promise<void>}
     */
    async assignLineNumbers(useServerMaxLineNumber = true) {
      let maxLineNo = this.entity.subQuoteNo * 1000
      if (!this.entity.isNew) {
        if (useServerMaxLineNumber) {
          maxLineNo = await QuoteService.getMaxLineNumber(this.entity.quoteId)
          if (maxLineNo === 0) maxLineNo = this.entity.subQuoteNo * 1000
        } else {
          // Local synced max: highest lineNumber already in use by non-new, non-deleted items
          // (those keep their numbers and won't be touched by the de-dupe loop below).
          const collections = ['labours', 'others', 'parts', 'miscs', 'sublets', 'opgs']
          maxLineNo = collections.reduce((max, key) => {
            return (this.entity[key] || []).reduce(
              (m, i) => (i && !i.isNew && !i.deleted && (i.lineNumber || 0) > m ? i.lineNumber : m),
              max
            )
          }, this.entity.subQuoteNo * 1000)
        }
      }

      let currentLineNumber = maxLineNo
      // sort if not audanet to make sure line numbers are sequential and not duplicated
      if (!this.entity.isAudaNet && !this.entity.isAudaBridge) {
        const entityItems = [...this.entity.labours, ...this.entity.others, ...this.entity.parts, ...this.entity.miscs, ...this.entity.sublets]
          .filter((i) => i.isNew)
          .sort((a, b) => {
            return a.lineNumber - b.lineNumber
          })

        // manipulate the array to update the line numbers,
        // for example: a: 1, b: 2, c: 2, d: 3 will become a: 1, b: 2, c: 3, d: 4
        entityItems.forEach((item) => {
          if (item.lineNumber > currentLineNumber) {
            currentLineNumber = item.lineNumber
          } else {
            currentLineNumber++
          }
          item.lineNumber = currentLineNumber
        })
        // Only update entity.lines for non-Audanet quotes.
        // Audanet/Audatext quotes have lineNumber=0 for all items; getMaxLineNumber returns 0,
        // so currentLineNumber would be subQuoteNo*1000 and setting entity.lines to that value
        // creates a spurious diff that triggers an unnecessary (and failing) putEntity call.
        this.entity.lines = useServerMaxLineNumber
          ? currentLineNumber + 1
          : Math.max(this.entity.lines || 0, currentLineNumber + 1)
      }
    },
    async toggleReadOnly() {
      if (!this.canChangeReadOnly) return
      if (this.autoSaveStatus.isSaving) return
      this.entity.readOnly = !this.entity.readOnly
      this.entity.readOnlyStatuses.splice(this.entity.subQuoteNo, 1, this.entity.readOnly)
      this.saveSnapshot(_cloneDeep(this.entity))
      if (this.autoSaveActiveForQuote) {
        // saveReadOnlyNow persists the lock immediately, so rebase it out of `snapshotDiff` —
        // only these two fields, or any other unsaved edit would be swallowed with it.
        this.setBaseSnapshotFields({
          entity: { readOnly: this.entity.readOnly, readOnlyStatuses: [...this.entity.readOnlyStatuses] },
          fields: ['readOnly', 'readOnlyStatuses']
        })
      }
      // With autosave off nothing is persisted here: the lock stays an unsaved change and the
      // manual Save carries it (the full quote PUT maps ReadOnly).
      await this.saveReadOnlyNow()
    },
    deletePaintLoadingItemFromEntity(item, quoteEntity) {
      if (!item || !quoteEntity) return
      if (item.isNew) {
        const itemIndex = quoteEntity.labours.findIndex((l) => l.quoteItemId === item.quoteItemId)
        if (itemIndex >= 0) {
          quoteEntity.labours.splice(itemIndex, 1)
        }
      } else {
        item.deleted = true
        item.isDeleted = true
        item.itemStatus = QuoteItemStatusTypes.Deleted
      }
    },
    async getDefaultPaintItemForQuote(itemNo, quoteEntity) {
      const filter = {
        countryId: Guid.empty(),
        companyId: quoteEntity.companyId,
        query: itemNo,
        butterflyCode: '',
        scheduleId: this.vehicle.scheduleId || '',
        bodyId: this.vehicle.bodyId || '',
        bodySize: '',
        paintGroup: this.vehicle.paintGroup || '',
        variantId: 0,
        nvic: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 1
      }
      return QuoteService.getAvailableLabourItems(filter, quoteEntity.labourType.toLowerCase())
    },
    async downloadPartsCheckPrice() {
      // Flush/save any pending changes first (autosave on) before fetching prices, so a
      // dirty quote no longer dead-ends on the "Quote has changed" toast. The toast only
      // surfaces when autosave is genuinely disabled and there are unsaved changes.
      const runDownload = async () => {
        this.$showSpinner('Fetching prices...')
        try {
          const clonedEntity = _cloneDeep(this.entity)
          const countryCode = this.$company.info.countryCode
          const priceUpdate = await PartsCheckService.getPartsCheckPrices(clonedEntity.quoteId)

          if (priceUpdate.parts.length > 0) {
            let nextLineNumber = this.nextLineNumber
            for (const partsCheckPart of priceUpdate.parts) {
              let part
              if (partsCheckPart.isNew) {
                part = new QuoteItemModel(clonedEntity.quoteId, partsCheckPart.itemNo, partsCheckPart.itemDesc, ItemCategoryTypes.PART)
                part.sortNo = clonedEntity.parts.length ? Math.max(...clonedEntity.parts.map((i) => i.sortNo)) + 1 : 1
                if (clonedEntity.isAudaNet) {
                  part.lineNumber = 0
                } else {
                  part.lineNumber = nextLineNumber
                }
                if (clonedEntity.isAudanet) {
                  part.rev = QuoteItemRevTypes.NonAudaNetPart
                }
              } else {
                part = clonedEntity.parts.find((i) => i.quoteItemId === partsCheckPart.quoteItemId)
                if (!part) {
                  continue
                }
                part.itemStatus = part.itemStatus != 'A' ? 'C' : part.itemStatus
              }

              if (countryCode !== 'MY' || (countryCode === 'MY' && partsCheckPart.isNew)) {
                part.value = partsCheckPart.unitPrice
                part.markupPercent = partsCheckPart.markupPercent
                part.markupValue = partsCheckPart.markupPrice
                part.mark = partsCheckPart.mark
              }

              part.itemQuantity = partsCheckPart.quantity
              part.buyPrice = partsCheckPart.buyPrice
              part.partNo = partsCheckPart.partNo
              part.side = partsCheckPart.side
              part.extLineId = partsCheckPart.partsCheckId
              part.partsCheckReferenceNo = partsCheckPart.partsCheckReferenceNo
              part.partStatus =
                part.itemComment === 'Part price variance - Not Authorised/Invoiced?' && part.reportOnly === true
                  ? ''
                  : part.partStatus !== 'Pord'
                  ? 'Imp'
                  : part.partStatus // don't update parts status for pending order
              if (part.isNew) {
                if (countryCode === 'MY') {
                  part.itemComment = 'Part added by supplier'
                  part.reportOnly = true
                } else {
                  part.itemComment = partsCheckPart.itemComment
                  part.reportOnly = partsCheckPart.reportOnly
                }
                clonedEntity.parts.splice(clonedEntity.parts.length, 1, part)
                if (!clonedEntity.isAudaNet) {
                  clonedEntity.lines = clonedEntity.nextLineNumber + 1
                  nextLineNumber++
                }
              }
              await syncPartPaintLoading({
                partItem: part,
                quoteEntity: clonedEntity,
                nextLineNumber: this.nextLineNumber,
                ntarLoadingItems: this.ntarLoadingItems,
                quoteInsurer: this.quoteInsurer,
                getDefaultPaintItem: (itemNo) => this.getDefaultPaintItemForQuote(itemNo, clonedEntity),
                deletePaintLoadingItem: (item) => this.deletePaintLoadingItemFromEntity(item, clonedEntity),
                defaultPaintGroup: this.vehicle.paintGroup
              })
            }

            this.entity = clonedEntity
            await this.save()
            this.showSuccessToast('PartsCheck price updates downloaded', 5000)
          } else {
            // this.$toast.open({
            //   message: 'There are no PartsCheck price updates',
            //   type: 'is-warning',
            //   queue: true,
            //   duration: 5000
            // })
            this.$notification.openNotificationWithType('warning', '', 'There are no PartsCheck price updates', 5000)
          }
        } catch {
        } finally {
          this.$hideSpinner()
        }
      }

      const result = await this.saveQuoteAndContinue(runDownload)
      if (!result?.ok && result?.reason === 'autosave-disabled') {
        this.showQuoteChangedToast()
      }

      this.updateStatusForQuote()

      this.$nextTick(() => {
        this.$eventHub.$emit(EventHubTypes.EntitySaved)
      })
    },

    async updateStatusForQuote() {
      const status = await this.fetchStatusForNumbers()
      // filter keys that have a value of "Withdrawn"
      const keys = Object.keys(status).filter((key) => status[key] == 'Withdrawn')

      if (!!keys.length) {
        // Preserve priced (IMP/MPR) and pending-order (Pord) parts even if the ref came back Withdrawn —
        // the duplicate-quote-number case can surface a stale Withdrawn draft (see FQ-2816).
        const preservedStatuses = ['IMP', 'MPR', 'PORD']
        let mutated = false
        this.entity.parts.forEach((part) => {
          if (!keys.includes(part.partsCheckReferenceNo.toString())) return
          const current = (part.partStatus || '').toUpperCase()
          if (preservedStatuses.includes(current)) return
          part.partStatus = ''
          mutated = true
        })

        if (mutated) {
          this.$notification.openNotificationWithType(
            'success',
            '',
            'Some parts have been withdrawn from PartsCheck. These can be priced and ordered again.',
            5000
          )
          await this.save()
        }
      }
    },
    viewPartsCheckRequest() {
      this.messageType = 'PartsCheck'
      this.isXmlViewerModalActive = true
    },
    // call to get status for a partscheck order, direct purchases and price parts
    async getStatusForNumber(refNumber) {
      const quoteNo = this.entity.prefix + this.entity.quoteNo + this.entity.suffix
      try {
        const status = await PartsCheckService.getQuotePartStatus(quoteNo, this.entity.subQuoteNo, refNumber)
        return { refNumber, status }
      } catch (error) {
        // Handle any errors if needed
        this.$notification.error('Error', 'Failed to get status for Quote Parts')
      }
    },
    async fetchStatusForNumbers() {
      let results = {}
      const numbers = [...new Set(this.entity.parts.map((i) => i.partsCheckReferenceNo))]
      for (const number of numbers) {
        const result = await this.getStatusForNumber(number)
        results[number] = result?.status
      }
      return results
    },
    addNewQuoteItems(existingItems, templateItems) {
      const existingItemsMap = new Map(existingItems.filter((i) => !i.deleted).map((item) => [`${item.itemNo}|${item.itemDesc}|${item.itemType}`, item]))
      const existingItemIds = new Set(existingItems.filter((i) => !i.deleted && i.quoteItemId).map((item) => item.quoteItemId))

      templateItems.forEach((templateItem) => {
        const key = `${templateItem.itemNo}|${templateItem.itemDesc}|${templateItem.itemType}`
        // Check both by composite key and by quoteItemId if it exists
        if (existingItemsMap.has(key) || (templateItem.quoteItemId && existingItemIds.has(templateItem.quoteItemId))) return

        let newQuoteItem = new QuoteItemModel(this.entity.quoteId, templateItem.itemNo, templateItem.itemDesc, templateItem.itemType)

        let rate = 0

        // add correct line number and sort number
        newQuoteItem.lineNumber = this.nextLineNumber
        newQuoteItem.sortNo = existingItems.length ? Math.max(...existingItems.map((i) => i.sortNo)) + 1 : 1

        switch (templateItem.itemType) {
          case ItemCategoryTypes.RR:
            rate = this.isNtar ? this.entity.shopRate : this.getLabourRate(ItemCategoryTypes.RR)
            break
          case ItemCategoryTypes.REP:
            rate = this.isNtar ? this.entity.shopRate : this.getLabourRate(ItemCategoryTypes.REP)
            break
          case ItemCategoryTypes.PAINT:
            rate = this.isNtar ? this.entity.shopRate : this.getLabourRate(this.vehicle.paintGroup)
            break
          default:
        }

        newQuoteItem.rate = rate ?? 0
        // this.isNtar &&

        if (
          templateItem.itemType === ItemCategoryTypes.PAINT ||
          templateItem.itemType === ItemCategoryTypes.REP ||
          templateItem.itemType === ItemCategoryTypes.RR
        ) {
          // calculate dollar value
          if (this.entity.quotingMethod == QuotingMethodTypes.Dollar) {
            const dollarValue = roundAwayFromZero(templateItem.value * newQuoteItem.rate)

            newQuoteItem.hourValue = dollarValue
            newQuoteItem.dollarValue = dollarValue
          } else {
            newQuoteItem.hourValue = templateItem.value
            newQuoteItem.dollarValue = newQuoteItem.hourValue
          }
        }

        newQuoteItem.reportOnly = templateItem.reportOnly
        newQuoteItem.value = templateItem.value

        if (templateItem.itemType == ItemCategoryTypes.PAINT) {
          newQuoteItem.opgCode = this.vehicle.paintGroup
        }

        existingItems.push(newQuoteItem)
        this.templateQuoteItemCount++
      })
    },

    async addRepairQuoteTemplateItems(id) {
      const templateItems = await QuoteTemplateService.getSortedQuoteTemplateItems(id)
      const LABOUR_ITEM_TYPES = new Set([ItemCategoryTypes.PAINT, ItemCategoryTypes.REP, ItemCategoryTypes.RR])
      const labourItems = templateItems.filter((i) => LABOUR_ITEM_TYPES.has(i.itemType))
      const miscItems = templateItems.filter((i) => i.itemType == ItemCategoryTypes.MISC)
      const otherItems = templateItems.filter((i) => i.itemType == ItemCategoryTypes.MECH)
      const subletItems = templateItems.filter((i) => i.itemType == ItemCategoryTypes.SUBL)

      this.addNewQuoteItems(this.entity.miscs, miscItems)
      this.addNewQuoteItems(this.entity.others, otherItems)
      this.addNewQuoteItems(this.entity.sublets, subletItems)

      if (this.isNtar) {
        this.getNtarTimesForTemplateLabour(labourItems)
      } else {
        this.addNewQuoteItems(this.entity.labours, labourItems)

        this.countNewQuoteItemNotification()
        this.templateQuoteItemCount = 0
        this.$nextTick(() => {
          this.updateQuoteItemsPage()
        })
      }
    },
    addRepairQuoteTemplateItemsCustom(obj) {
      console.log('obj from template', obj)

      // return

      this.addNewQuoteItems(this.entity.miscs, obj.miscItems)
      this.addNewQuoteItems(this.entity.others, obj.otherItems)
      this.addNewQuoteItems(this.entity.sublets, obj.subletItems)
      this.addNewQuoteItems(this.entity.parts, obj.partItems)

      if (this.isNtar) {
        this.getNtarTimesForTemplateLabour(obj.labourItems)
      } else {
        this.addNewQuoteItems(this.entity.labours, obj.labourItems)

        this.countNewQuoteItemNotification()
        this.templateQuoteItemCount = 0
        this.$nextTick(() => {
          this.updateQuoteItemsPage()
          this.scheduleItemsSave()
        })
      }
    },

    // get labour times for a template when applying to a ntar quote
    async getNtarTimesForTemplateLabour(labourArr) {
      console.log(this.entity)

      if (this.vehicle.ntarScheduleId == '' || this.vehicle.bodyId == '' || this.entity.labourType == '') {
        return labourArr
      }

      const filter = {
        countryId: Guid.empty(),
        companyId: Guid.empty(),
        query: '',
        butterflyCode: '',
        scheduleId: this.vehicle.ntarScheduleId || '',
        bodyId: this.vehicle.bodyId || '',
        bodySize: '',
        paintGroup: this.vehicle.paintGroup || '',
        variantId: 0,
        nvic: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 999
      }
      const data = await QuoteService.getAvailableLabourItems(filter, this.entity.labourType)

      labourArr.forEach((templateItem) => {
        const labourItem = data.find((i) => i.itemNo == templateItem.itemNo)
        if (labourItem) {
          console.log('labourItem', labourItem)

          templateItem.value =
            templateItem.itemType == ItemCategoryTypes.PAINT
              ? labourItem.paintHour
              : templateItem.itemType == ItemCategoryTypes.REP
              ? labourItem.repairHour
              : labourItem.rrHour
        }
      })

      console.log('labourItems', labourArr)

      // return

      console.log('labourItems', labourArr)
      this.addNewQuoteItems(this.entity.labours, labourArr)

      this.countNewQuoteItemNotification()
      this.templateQuoteItemCount = 0
      this.$nextTick(() => {
        this.updateQuoteItemsPage()
        this.scheduleItemsSave()
      })
    },

    // updates the data on quote items page so changes made from templates etc can be
    // reflected right away
    updateQuoteItemsPage() {
      this.$eventHub.$emit('updateLabour')
      this.$eventHub.$emit('updateOthers')
      this.$eventHub.$emit('updateParts')
      this.$eventHub.$emit('updateMiscs')
      this.$eventHub.$emit('updateSublets')
    },

    countNewQuoteItemNotification() {
      if (!this.templateQuoteItemCount > 0) {
        // return this.$toast.open({
        //   message: 'No item added',
        //   type: 'is-warning',
        //   position: 'is-top',
        //   queue: false
        // })
        return this.$notification.warning('', 'No item added')
      }
      // return this.$toast.open({
      //   message: `${this.templateQuoteItemCount} Items added`,

      //   type: 'is-success',
      //   position: 'is-top',
      //   queue: false
      // })
      return this.$notification.success('', `${this.templateQuoteItemCount} Items added`)
    },
    reloadQuoteImages() {
      if (this.$router.currentRoute.name == QuoteRoutes.QuoteImages.name) {
        if (this.$refs.currentChild.reload) {
          this.$refs.currentChild.reload()
        }
      }
    },
    async handleSaveRepxRepairStages(data) {
      var repxStageSetting = await RepxService.getRepxRepairStageSettings(data.Stage)
      if (repxStageSetting) {
        this.entity.jobStage = repxStageSetting.jobStage
        this.entity.subJobStage = repxStageSetting.subJobStage
      }
      const isSaved = await this.save()
      if (isSaved) {
        if (this.$refs.currentChild.saveRepxRepairStages) {
          const isRepxStageSaved = await this.$refs.currentChild.saveRepxRepairStages(data) //QuoteRepx
          console.log(`isRepxStageSaved: ${isRepxStageSaved}`)
          if (isRepxStageSaved) {
            await this.getEntity(true)
          }
        }
      } else {
        if (this.$refs.currentChild.resetSaveModal) {
          this.$refs.currentChild.resetSaveModal() //QuoteRepx
        }
      }
    },
    modifySelections() {
      // Open butterfly modal for vehicle part selection
      // this.isButterflyModalActive = true
      this.isVehicleButterflyModalActive = true
    },
    async resetSelections() {
      this.selectedSubSections = []
      this.isVehicleButterflyModalActive = false
      if (this.entity && this.entity.quoteId) {
          await QuoteService.updateQuoteButterfly(this.entity.quoteId, [])
      }
      await this.loadButterflySelections()
    },
    async handleVehicleButterflyDone() {
      this.isVehicleButterflyModalActive = false
      await this.loadButterflySelections()
    },
    async handleVehicleButterflyCancel() {
      this.isVehicleButterflyModalActive = false
      await this.loadButterflySelections()
    },
    goToRoute(route) {
      if (this.entity && !this.entity.isNew) {
        this.$router.push(route)
      }
    },
    async getCompanyExternalSetting() {
      this.planningSetting = await CompanyService.getCompanyExternalSetting('Planning Plus')
    },
    async loadButterflySelections() {
      if (this.entity && this.entity.quoteId) {
        const quoteButterfly = await QuoteService.getQuoteButterfly(this.entity.quoteId)
        if (quoteButterfly.length) {
          let firstSelectedFound = false
          const newSelections = quoteButterfly.map((item) => {
            let isFilter = false
            if (!firstSelectedFound && item.isSelected) {
              isFilter = true
              firstSelectedFound = true
            }
            return {
              partId: item.butterflyCode,
              id: item.butterflyCode, // Add id property for compatibility
              partName: item.butterflyDesc,
              area: item.area,
              selected: item.isSelected,
              sortOrder: item.sortOrder,
              isFilter
            }
          })

          this.selectedSubSections.splice(0, this.selectedSubSections.length, ...newSelections)
        } else {
          this.selectedSubSections.splice(0, this.selectedSubSections.length)
        }
      }
    },
    setInnerJobNSubJobStageCompositeKey() {
      console.log('setInnerJobNSubJobStageCompositeKey')
      if (this.entity) {
        let jobStage = this.entity.jobStage
        if (jobStage) {
          let subJobStage = this.entity.subJobStage || ''
          this.innerJobNSubJobStageCompositeKey = jobStage + '|' + subJobStage
        }
      }
    },
    filterByArea(area) {
      this.selectedArea = area
    },
    //TEMP check for GEMCan company - REMOVE AFTER ASSESSMENT HISTORY PHASE 2
    tempGemCan() {
      return this.$userInfo.isCustomerAdministrator && this.$company.info.companyId === 'a5ffbdc0-41d2-4e7f-8ecf-e51beac57e6b'
    },
    availableItemsTypeChanged(type) {
      this.availableItemsType = type
    },
    truncate(str, maxLength, suffix = '...') {
      if (typeof str !== 'string') return ''
      if (maxLength === 0) return ''
      if (str.length === -1) return str
      if (str.length <= maxLength) return str
      return str.slice(0, maxLength - suffix.length) + suffix
    },
    setInitialQuoteCustomer() {
      this.initialQuoteCustomer = _cloneDeep(this.customer)
    }
    // hasChangesOutsideExpandedItem(quoteDiff, expandedItemId) {
    //   // Check if changes exist outside of the expanded/editing item
    //   const itemCollections = ['labours', 'parts', 'others', 'miscs', 'sublets', 'opgs']

    //   for (const diff of quoteDiff) {
    //     const path = diff.path
    //     if (!path || path.length === 0) continue

    //     const topLevelProperty = path[0]

    //     // If change is not in item collections, it's a change we want to save
    //     if (!itemCollections.includes(topLevelProperty)) {
    //       return true
    //     }

    //     // If change is in item collections, check if it's related to the expanded item
    //     if (path.length >= 2) {
    //       const itemIndex = path[1]
    //       const collection = this.entity[topLevelProperty]

    //       if (collection && collection[itemIndex]) {
    //         const item = collection[itemIndex]
    //         // If the change is not related to the expanded item, we should save
    //         if (item.quoteItemId !== expandedItemId) {
    //           return true
    //         }
    //       }
    //     }
    //   }

    //   return false
    // }
  },
  async beforeRouteLeave(to, from, next) {

    const isEditInsurer = to.name === InsurerRoutes.InsurerDetail.name
    const isEditVehile = to.name === VehicleRoutes.VehicleDetail.name

    if (isEditInsurer || isEditVehile) {
      next()
      return
    }

    if (this.isCustomerCreateModifyModalActive) {
      this.toRoute = to
      next(false)
      return
    }

    // Purge empty (blank) line items on leave — they are never persisted. Skipped for
    // new quotes: they may still get the unsaved-changes prompt below, and the draft
    // must not be mutated before the user decides to stay.
    if (this.autoSaveActiveForQuote) {
      this.deleteEmptyLineItems()
    }

    if (!this.skipNextNavWarning && this.autoSaveEnabled && this.autoSaveStatus.isFailed) {
      // Show navigation warning if autosave failed
      this.$router.replace(from.path)
      this.toRoute = to
      this.navigationWarningMessage = 'Autosave has failed. Would you like to try saving manually before navigating away, or skip and navigate away anyway?'
      this.navigationWarningAction = 'trySave'
      this.isNavigationWarningModalActive = true
      return
    }

    this.skipNextNavWarning = false
    // Skip unsaved modal only when autosave actually covers this quote — new quotes are
    // never autosaved, so they must still get the prompt or the draft is silently lost.
    if (!this.autoSaveActiveForQuote && this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue && !this.readOnlyView && !this.skipNextUnsavedModal) {
      console.log(this.snapshotDiff)
      this.$router.replace(from.path)
      this.toRoute = to
      this.isUnsavedModalActive = true
      return
    }

    this.skipNextUnsavedModal = false

    // Force a save when leaving the quote (existing quotes only).
    // Use the QuoteView.save() method so the global loading spinner is shown.
    try {
      const isExistingQuote = !!this.entity && !this.entity.isNew
      const canSave = isExistingQuote && !this.readOnlyView && !this.isSkipSave && !this.isSaveContinue
      const hasUnsavedChanges = !!this.snapshotDiff || !!this.autoSaveStatus?.isDiffChanged

      if (canSave && hasUnsavedChanges) {
        // Cancel any pending autosave calls and invalidate in-flight autosave pipelines.
        // We want navigation-leave to be a single, deliberate save via QuoteView.save().
        if (this.autoUpdateQuoteHeader && typeof this.autoUpdateQuoteHeader.cancel === 'function') this.autoUpdateQuoteHeader.cancel()
        if (this.scheduleItemsSave && typeof this.scheduleItemsSave.cancel === 'function') this.scheduleItemsSave.cancel()

        // Invalidate any already-started autosave promises so their callbacks won't clobber state.
        this.headerAutosaveToken += 1
        this.headerAutosaveInFlight = false
        if (this.stopQuoteItemsEditDeferMonitor) this.stopQuoteItemsEditDeferMonitor()

        // Clear autosave "saving" flag since we're taking over with a manual save.
        if (this.setAutoSaveState) this.setAutoSaveState({ isSaving: false })

        const ok = await this.save(false, false, false, true)
        if (!ok) {
          // If save triggered the customer modal, block navigation quietly — customer modal is already showing
          if (this.isCustomerCreateModifyModalActive) {
            this.toRoute = to
            next(false)
            return
          }
          if (!this.leaveWithUnsavedErrors) {
            // Save failed (e.g. validation errors) — ask user if they want to leave anyway
            next(false)
            this.toRoute = to
            this.navigationWarningMessage = 'There are errors that could not be saved. Would you like to leave without saving, or stay to fix the errors?'
            this.navigationWarningAction = 'leaveWithErrors'
            this.isNavigationWarningModalActive = true
            return
          }
          // User already chose to leave with unsaved errors — reset flag and fall through to next()
          this.leaveWithUnsavedErrors = false
        }
      }
    } catch (e) {
      // If the forced save throws, keep the user on the quote.
      console.error('Forced save on navigation failed:', e)
      next(false)
      return
    }

    this.setReturnRoute({})
    this.clearSessionStorage()
    this.clearSnapshots(from.params.quoteId)
    this.clearHeaders()
    this.clearInvoiceState()
    next()
  },
  async beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')

    if (this.isCustomerCreateModifyModalActive) {
      this.toRoute = to
      next(false)
      return
    }

    const isWithinQuote = QuoteRoutes.hasOwnProperty(to.name) && to.params.quoteId === from.params.quoteId
    const isWithinQuoteGroup = QuoteRoutes.hasOwnProperty(to.name) && to.params.quoteId !== from.params.quoteId

    const isPartsControlRoute = to.name === QuoteRoutes.QuotePartsControl.name

    const isQuoteBuilderRoute = to.name === QuoteRoutes.QuoteBuilder.name

    const isFromQuoteBuilder = from.name === QuoteRoutes.QuoteBuilder.name
    const isToQuoteHeader = to.name === QuoteRoutes.QuoteHeader.name

    if (isWithinQuote) {
      console.log('isNextRouteWithinQuote')

      // Leaving the builder for ANY other tab: purge blank new lines and revert emptied
      // synced lines — they are never persisted. Must run before the snapshotDiff checks
      // below so they don't register as unsaved changes. Skipped for new quotes so the
      // draft isn't mutated before the unsaved-changes prompt.
      if (isFromQuoteBuilder && this.autoSaveActiveForQuote) {
        this.deleteEmptyLineItems()
      }

      // Hard save when navigating from the quoting builder back to the header
      if (isFromQuoteBuilder && isToQuoteHeader) {
        const isExistingQuote = !!this.entity && !this.entity.isNew
        const canSave = isExistingQuote && !this.readOnlyView && !this.isSkipSave && !this.isSaveContinue
        const hasUnsavedChanges = !!this.snapshotDiff || !!this.autoSaveStatus?.isDiffChanged

        if (canSave && hasUnsavedChanges) {
          // Cancel any pending autosave calls and invalidate in-flight pipelines
          if (this.autoUpdateQuoteHeader && typeof this.autoUpdateQuoteHeader.cancel === 'function') this.autoUpdateQuoteHeader.cancel()
          if (this.scheduleItemsSave && typeof this.scheduleItemsSave.cancel === 'function') this.scheduleItemsSave.cancel()

          this.headerAutosaveToken += 1
          this.headerAutosaveInFlight = false
          if (this.stopQuoteItemsEditDeferMonitor) this.stopQuoteItemsEditDeferMonitor()

          if (this.setAutoSaveState) this.setAutoSaveState({ isSaving: false })

          await this.save(false, false, false, true)
          // Don't block navigation to the header even if save failed (e.g. validation errors) —
          // the header is where the user goes to fix those errors.
        }
        next()
        return
      }

      // Ignore snapshotDiff within quote routes except for parts control
      if ((isPartsControlRoute || isQuoteBuilderRoute) && this.snapshotDiff) {
        // try to save the quote
        const saveStatus = await this.save()
        // If save triggered the customer modal, block navigation and queue the destination
        if (this.isCustomerCreateModifyModalActive) {
          this.toRoute = to
          next(false)
          return
        }
        if (!saveStatus) {
          this.$notification.error('Error', 'Save failed. Save the quote before making changes in ' + to.name)
        }
        next()
      } else next()
    } else if (isWithinQuoteGroup) {
      // Skip unsaved modal if autosave is active for this quote (new quotes are never autosaved)
      if (!this.autoSaveActiveForQuote && this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue && !this.readOnlyView) {
        console.log('switch', this.snapshotDiff)
        this.$router.replace(from.path)
        this.toRoute = to
        this.isUnsavedModalActive = true
      } else {
        // Switch quote without changing route
        console.log('switch')
        this.$showSpinner()
        this.setPreviousQuoteId(from.params.quoteId)
        this.isSkipSave = false
        this.toRoute = null
        this.clearSessionStorage()
        this.clearSnapshots(from.params.quoteId)
        // Only clear vehicle/customer/insurer headers when coming from outside the quote
        // module (e.g. quote list). Copy quote and new additional navigate from within a
        // quote route and pre-load their own headers, so clearing here would wipe freshly-
        // fetched data.
        if (!QuoteRoutes.hasOwnProperty(from.name)) {
          this.clearHeaders()
        }
        this.clearInvoiceState()
        await this.getStoreItem(to.params.quoteId)
        // Pass the destination id — this.$route still points to the OLD route until next()
        // confirms the navigation, so getEntity must not read the quote id from it here.
        await this.getEntity(false, false, to.params.quoteId)
        const imageIds = await QuoteService.getImageIds(this.entity.quoteId)
        this.$eventHub.$emit(EventHubTypes.ImageCountChanged, imageIds.length)
        const attachments = await QuoteService.getQuoteAttachments(this.entity.quoteId)
        let count = Object.values(attachments.data).reduce((total, row) => total + Object.values(row.quoteAttachments).length, 0)
        this.$eventHub.$emit(EventHubTypes.DocumentCountChanged, count)
        this.$v.entity.$reset()
        if (!this.entity.isNew) {
          // console.log('switch hhh')
          this.setReturnRoute({})
        }
        this.$hideSpinner()
        next()
        this.setPreviousQuoteId('')
      }
    }
    // else if (this.snapshotDiff && !this.isSkipSave && !this.isSaveContinue) {
    //   console.log(this.snapshotDiff)
    //   this.$router.replace(from.path)
    //   this.toRoute = to
    //   this.isUnsavedModalActive = true
    // } else {
    //   // console.log('next', to, from)
    //   this.clearSnapshots(this.entity.quoteId)
    //   this.clearSessionStorage()
    //   next()
    // }
  }
}
</script>

<style lang="scss" scoped>
// Autosave toggle switch
.autosave-toggle-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;

  .switch[type="checkbox"] {
    &:checked + label::before {
      background-color: hsl(171, 100%, 41%);
    }
  }

  label {
    margin-bottom: 0;
    cursor: pointer;
    user-select: none;
  }
}

// .custom-tag-job-stage {
//   background-color: #34AF85;
//   color: #fff;
//   font-size: 0.9em;
// }
.horizontal-menu-article {
  display: flex;
  flex-direction: column;
}
.quote-header-row {
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
  gap: 1rem;

  > div:not(:last-child) {
    border-right: 1px solid var(--divider-background-color);;
    padding-right: 1rem;
  }

  .quote-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    .subtitle {
      margin-bottom: 0 !important;
    }
  }
  .subquotes-tabs {
    .tags {
      margin-bottom: 0;
      gap: 0.5rem;

      .tag {
        font-size: 0.9em;
        text-decoration: none;
        // transition: all 0.2s ease;

        // &:hover:not(.is-disabled) {
        //   transform: translateY(-1px);
        //   box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        // }

        // border: solid 1px #C4CCD4;
        // color: #C4CCD4;

        // &.is-primary {
        //   font-weight: 600;
        //   background-color: #3273dc;
        // }

        &.is-disabled {
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        }
      }
    }
  }
}
.quote-body {
  position: relative;
  z-index: 20;
}
.is-synced-icon {
  position: absolute;
  // margin-top: -0.1em;
  margin-left: -0.8em;
}
.is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
  a {
    display: inline-block;
    text-decoration: none;
  }
}
.job-stage {
  background-color: #f9bf00 !important;
  border-radius: var(--bulma-radius-rounded) !important;
  color: #000 !important;
  font-size: 0.9em;

}
.job-stage-select select {
  background-color: #f9bf00 !important;
  // border-color: #f9bf00 !important;
  border-radius: var(--bulma-radius-rounded) !important;
  color: #000 !important;
  font-size: 0.9em;

  option, optgroup {
    background-color: var(--background-color);
    color: var(--bulma-label-color);
  }
}
.is-divider {
    margin: 0.5rem 0;
}
.quote-header-info {
  max-width: calc(100vw - 50rem);
  //overflow-x: auto;
  //overflow-y: hidden;
  gap: 1rem;

  > div:not(:last-child) {
    border-right: 1px solid var(--divider-background-color);
    padding-right: 1rem;
  }
  div > span {
    white-space: nowrap;
  }
}

.thin-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #aaa transparent;
}
.thin-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.thin-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.thin-scrollbar::-webkit-scrollbar-thumb {
  background-color: #aaa;
  border-radius: 20px;
}

.new-owner-prompt-container {
  .field {
    background-color: var(--bulma-background-color);
    border-radius: 4px;
    cursor: pointer;
  }
  .custom-radio.radio input[type=radio] + .check {
    height: 0.8em;
    width: 1em;
  }
}

</style>